<template>
  <SidebarComponent />

  <div class="dashboard-layout staff-questionnaires-page">
    <div class="content-container">
      <div class="card-container">

        <!-- Titolo + filtri -->
        <div class="titolo-card">
          <h1>Elenco Questionari</h1>
        </div>

        <section class="toolbar-card card-surface">
          <div class="filters-header">
            <button
              type="button"
              class="accordion-toggle"
              @click="filtersOpen = !filtersOpen"
              :aria-expanded="filtersOpen"
            >
              <div class="toggle-copy">
                <span class="toggle-title">Filtri e ricerca</span>
                <span class="toggle-subtitle">Stato admin, step, studio, date</span>
              </div>
              <span class="material-icons" aria-hidden="true">
                {{ filtersOpen ? 'expand_less' : 'expand_more' }}
              </span>
            </button>
          </div>

          <transition name="accordion">
            <div v-show="filtersOpen" class="accordion-panel">
              <div class="toolbar">


                <div class="toolbar-group toolbar-group--sm">
                  <label class="toolbar-label" for="q-from">Dal</label>
                  <input
                    id="q-from"
                    type="date"
                    v-model="dateFrom"
                    class="input date-range-input date-range-input--short"
                    aria-label="Data da"
                  />
                </div>

                <div class="toolbar-group toolbar-group--sm">
                  <label class="toolbar-label" for="q-to">Al</label>
                  <input
                    id="q-to"
                    type="date"
                    v-model="dateTo"
                    class="input date-range-input date-range-input--short"
                    aria-label="Data a"
                  />
                </div>

                
                <div class="toolbar-group toolbar-group--md">
                  <label class="toolbar-label" for="q-admin">Stato admin</label>
                  <select id="q-admin" v-model="selectedAdmin" class="input" @change="applyCombinedFilter">
                    <option value="">Tutti</option>
                    <option value="needs_update">Richiesto aggiornamento</option>
                    <option value="updated">Aggiornato</option>
                    <option value="todo">Da lavorare</option>
                    <option value="none">—</option>
                  </select>
                </div>

                <div class="toolbar-group toolbar-group--md">
                  <label class="toolbar-label" for="q-step">Step</label>
                  <select id="q-step" v-model="selectedStepKey" class="input" @change="applyCombinedFilter">
                    <option value="">Tutti</option>
                    <option value="questionario">questionario</option>
                    <option value="feedback_programmi">feedback_programmi</option>
                    <option value="check_finale">check_finale</option>
                  </select>
                </div>

                <div class="toolbar-group toolbar-group--sm">
                  <label class="toolbar-label" for="q-rating">Valutazione</label>
                  <select id="q-rating" v-model="selectedValutazione" class="input" @change="applyCombinedFilter">
                    <option value="">Tutte</option>
                    <option value="1-2">1–2</option>
                    <option value="3">3</option>
                    <option value="4-5">4–5</option>
                  </select>
                </div>

                <div class="toolbar-group toolbar-group--lg">
                  <label class="toolbar-label" for="q-studio">Studio</label>
                  <select id="q-studio" v-model="selectedStudio" class="input" @change="applyCombinedFilter">
                    <option value="">Tutti</option>
                    <option v-for="studio in studioOptions" :key="studio" :value="studio">
                      {{ studio }}
                    </option>
                  </select>
                </div>


                <div class="toolbar-actions">
                  <button class="btn primary staff-button-neutral" type="button" @click="applyCombinedFilter">
                    Cerca
                  </button>
                  <button class="btn ghost" @click="resetFilters">Reset</button>
                </div>

                <div class="toolbar-actions toolbar-actions--ghosts">
                  <button
                    class="btn ghost"
                    :class="{ active: showSent }"
                    type="button"
                    @click="toggleShowSent"
                  >
                    {{ showSent ? 'Nascondi inviati' : 'Mostra inviati' }}
                  </button>

                  <button
                    class="btn ghost"
                    :class="{ active: showStopped }"
                    type="button"
                    @click="toggleShowStopped"
                  >
                    {{ showStopped ? 'Mostra non stop' : 'Mostra Stop' }}
                  </button>

                  <button
                    class="btn ghost"
                    :class="{ active: showToRenew }"
                    type="button"
                    @click="toggleShowToRenew"
                  >
                    {{ showToRenew ? 'Mostra non da rinnovare' : 'Mostra da rinnovare' }}
                  </button>
                </div>
              </div>
            </div>
          </transition>
        </section>

        <!-- Loader -->
        <div v-if="isLoading" class="loader"><h4>Caricamento…</h4></div>

        <!-- Tabella -->
        <template v-else>
          <div v-if="filteredQuestionari.length" class="tickets questionnaires-list">
            <table class="questionnaires-table">
              <thead>
                <tr>
                  <th class="col-idx">#</th>
                  <th class="col-azione">Azioni</th>
                  <th class="col-admin">Stato admin</th>
                  <th class="col-note">Note</th>
                  <th class="col-data">Data</th>
                  <th class="col-email">Utente (email)</th>
                  <th class="col-pagamenti">Pagamenti</th>
                  <th v-if="showToRenew" class="col-acquisto-flag">Acquisto</th>
                  <th v-if="showToRenew" class="col-acquisto">Ultimo acquisto</th>
                  <th v-if="showToRenew" class="col-acquisto-data">Data acquisto</th>
                  <th class="col-studio">Studio</th>
                  <th class="col-prodotto">Prodotto</th>
                  <th class="col-sequenza">Sequenza</th>
                  <th class="col-step">Step</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(q, i) in filteredQuestionari"
                  :key="q.id"
                  class="questionnaire-row"
                  :class="[
                    feedbackColor(q),
                    isPostRenewalPurchaseRow(q) ? 'row-purchase-renewal' : '',
                    q.isStopped ? 'row-stop' : '',
                    duplicateUids.has(q.uid) ? 'row-duplicate' : '',
                    isPaymentIssueRow(q) ? 'row-payment-issue' : '',
                    { 'questionnaire-row--expanded': mobileExpandedQuestionari.has(q.id) },
                  ]"
                >
                  <td class="mono questionnaire-index" data-label="#">{{ i + 1 }}</td>

                  <td class="questionnaire-actions" data-label="Azioni">
                    <button
                      class="profile-button"
                      @click="handleQuestionarioClick(q)"
                      :title="questionarioLinkLabel(q)"
                      :aria-label="questionarioLinkLabel(q)"
                    >
                      <span class="material-icons" aria-hidden="true">article</span>
                    </button>
                    <button class="profile-button" @click="gotoUser(q.uid)" :disabled="!q.uid" aria-label="Apri profilo utente">
                      <span class="material-icons" aria-hidden="true">visibility</span>
                    </button>
                  </td>

                  <!-- ======= STATO ADMIN ======= -->
                  <td class="admin-col" data-label="Stato admin">
                    <div class="admin-row">
                    <div class="chips-line">
                      <span class="admin-chip" :class="adminChipClass(q.adminStatus)">
                        {{ adminLabel(q.adminStatus) }}
                      </span>
                      <span
                        v-if="isDailyMarked(q)"
                        class="admin-chip"
                        :class="dailySentChipClass(q)"
                      >
                        {{ dailySentChipLabel(q) }}
                      </span>
                      <span v-if="q.needsRenewal" class="admin-chip chip-purple">
                        Da rinnovare
                      </span>
                      <span v-if="q.isStopped" class="admin-chip chip-red">
                        Stop
                      </span>
                    </div>
                      <div class="buttons-container questionnaire-admin-actions">
                        <button
                          type="button"
                          class="icon-btn green"
                          :disabled="!q.percorsoIdValid || q._saving"
                          :title="q.adminStatus === 'approved' ? 'Disapprova' : 'Approva'"
                          :aria-label="q.adminStatus === 'approved' ? 'Disapprova' : 'Approva'"
                          @click="toggleAdminApproved(q)"
                        >
                          <span class="material-icons" aria-hidden="true">
                            {{ q.adminStatus === 'approved' ? 'undo' : 'check' }}
                          </span>
                        </button>

                        <button
                          type="button"
                          class="icon-btn orange"
                          :disabled="!q.percorsoIdValid"
                          title="Richiedi aggiornamento"
                          aria-label="Richiedi aggiornamento"
                          @click="toggleNeedsUpdateUI(q)"
                        >
                          <span class="material-icons" aria-hidden="true">edit_note</span>
                        </button>
                        <button
                          v-if="canShowDailySend(q)"
                          type="button"
                          class="icon-btn blue"
                          :disabled="!q.percorsoIdValid || savingDaily[keyFor(q)]"
                          :title="savingDaily[keyFor(q)] ? 'Invio…' : 'Invio'"
                          :aria-label="savingDaily[keyFor(q)] ? 'Invio…' : 'Invio'"
                          @click="markDailySend(q)"
                        >
                          <span class="material-icons" aria-hidden="true">
                            {{ savingDaily[keyFor(q)] ? 'hourglass_top' : 'send' }}
                          </span>
                        </button>
                        <button
                          v-if="canShowDailyHide(q)"
                          type="button"
                          class="icon-btn grey"
                          :disabled="!q.percorsoIdValid || savingDaily[keyFor(q)]"
                          :title="savingDaily[keyFor(q)] ? 'Nascondo…' : 'Nascondi'"
                          :aria-label="savingDaily[keyFor(q)] ? 'Nascondo…' : 'Nascondi'"
                          @click="markDailyFlagOnly(q)"
                        >
                          <span class="material-icons" aria-hidden="true">
                            {{ savingDaily[keyFor(q)] ? 'hourglass_top' : 'visibility_off' }}
                          </span>
                        </button>
                        <button
                          v-if="q.adminStatus === 'approved'"
                          type="button"
                          class="renew-btn"
                          :disabled="!q.percorsoIdValid || q._savingRenewal"
                          :title="q.needsRenewal ? 'Rimuovi rinnovo' : 'Da rinnovare'"
                          :aria-label="q.needsRenewal ? 'Rimuovi rinnovo' : 'Da rinnovare'"
                          @click="toggleRenewal(q)"
                        >
                          <span class="material-icons" aria-hidden="true">
                            {{ q.needsRenewal ? 'restart_alt' : 'autorenew' }}
                          </span>
                        </button>

                        <button
                          v-if="q.adminStatus === 'approved'"
                          type="button"
                          class="stop-btn"
                          :disabled="!q.percorsoIdValid || q._savingStop"
                          :title="q.isStopped ? 'Ripristina' : 'Stop'"
                          :aria-label="q.isStopped ? 'Ripristina' : 'Stop'"
                          @click="toggleStop(q)"
                        >
                          <span class="material-icons" aria-hidden="true">
                            {{ q.isStopped ? 'play_arrow' : 'block' }}
                          </span>
                        </button>

                      </div>
                    </div>

                    <!-- box nota quando “Richiesto aggiornamento” -->
                    <div v-if="needsUpdateOpen[keyFor(q)]" class="needs-box">
                      <textarea
                        class="user-input"
                        v-model.trim="needsUpdateNotes[keyFor(q)]"
                        aria-label="Nota della richiesta di aggiornamento"
                        placeholder="Scrivi la nota per l'utente…"
                      ></textarea>
                      <div class="buttons-container">
                        <button type="button" class="create-user-button staff-button-positive" :disabled="q._saving"
                                @click="saveNeedsUpdate(q)">
                          {{ q._saving ? 'Salvataggio…' : 'Salva richiesta' }}
                        </button>
                        <button type="button" class="action-button2" @click="toggleNeedsUpdateUI(q)">
                          Chiudi
                        </button>
                      </div>

                      <small v-if="(q.adminNote||'').length" class="muted">
                        Nota corrente: “{{ q.adminNote }}”
                      </small>
                    </div>
                    <small v-else-if="(q.adminNote||'').length" class="muted questionnaire-admin-note">
                      Nota: “{{ q.adminNote }}”
                    </small>
                  </td>

                  <!-- ======= NOTE (editable) ======= -->
<td class="questionnaire-notes questionnaire-secondary-cell" data-label="Note interne">
  <p v-if="staffNoteEdits[keyFor(q)]" class="questionnaire-note-preview">{{ staffNoteEdits[keyFor(q)] }}</p>
  <input
    class="note-input"
    aria-label="Note interne"
    :placeholder="'—'"
    v-model="staffNoteEdits[keyFor(q)]"
    @blur="saveStaffNote(q)"
    @keyup.enter="saveStaffNote(q)"
                    :disabled="q._savingNote"
  />
  <small v-if="q._savingNote" class="muted">salvo…</small>
  <small v-else-if="saveStatus[keyFor(q)]==='ok'" class="muted">salvato ✓</small>
  <small v-else-if="saveStatus[keyFor(q)]==='err'" class="muted">errore ✗</small>
</td>

                  <td class="questionnaire-date" data-label="Data">{{ formatDateTime(q.updatedAt || q.createdAt) }}</td>
                  <td class="mono questionnaire-email" data-label="Utente">{{ userEmails[q.uid] || '—' }}</td>
                  <td class="questionnaire-payments" data-label="Pagamenti">
                    <span class="payment-chip" :class="paymentChipClass(q)" :title="paymentChipTitle(q)">
                      {{ paymentChipLabel(q) }}
                    </span>
                    <small class="questionnaire-payment-detail">{{ paymentChipTitle(q) }}</small>
                  </td>
                  <td v-if="showToRenew" class="questionnaire-purchase-flag" data-label="Acquisto">
                    <span class="purchase-chip" :class="purchaseChipClass(q)">
                      {{ purchaseChipLabel(q) }}
                    </span>
                  </td>
                  <td
                    v-if="showToRenew"
                    class="questionnaire-purchase-product questionnaire-secondary-cell"
                    data-label="Ultimo acquisto"
                    :title="latestOrderProductLabel(q)"
                    :class="latestOrderProductClass(q)"
                  >
                    {{ latestOrderProductLabel(q) }}
                  </td>
                  <td v-if="showToRenew" class="questionnaire-purchase-date questionnaire-secondary-cell" data-label="Data acquisto">{{ latestOrderDateLabel(q) }}</td>
                  <td class="questionnaire-studio questionnaire-secondary-cell" data-label="Studio">{{ userStudios[q.uid] || '—' }}</td>
                  <td class="questionnaire-product" data-label="Prodotto">{{ q.productName || '—' }}</td>
                  <td class="questionnaire-sequence" data-label="Sequenza">
                    <span v-if="q.sequenceIndex != null">
                      {{ q.sequenceIndex }}<span v-if="q.sequenceTotal">/{{ q.sequenceTotal }}</span>
                    </span>
                    <span v-else>—</span>
                  </td>
                  <td class="mono questionnaire-step" data-label="Step">
                    <div class="step-cell">
                      <span>{{ q.stepKey || '—' }}</span>
                      <span v-if="stepCloneLabel(q)" class="step-tag">· {{ stepCloneLabel(q) }}</span>
                    </div>
                  </td>
                  <td class="questionnaire-mobile-footer">
                    <button
                      type="button"
                      class="questionnaire-mobile-expand"
                      @click="toggleMobileQuestionario(q)"
                      :aria-expanded="mobileExpandedQuestionari.has(q.id)"
                    >
                      <span>{{ mobileExpandedQuestionari.has(q.id) ? 'Chiudi altri campi' : 'Gestisci e altri campi' }}</span>
                      <span class="material-icons" aria-hidden="true">{{ mobileExpandedQuestionari.has(q.id) ? 'expand_less' : 'expand_more' }}</span>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div v-else class="muted">Nessun questionario.</div>
        </template>
      </div>
    </div>
  </div>

  <!-- Modale risposte -->
  <div v-if="showModal" class="modal staff-questionnaire-modal">
    <div class="dialog" role="dialog" aria-modal="true" aria-labelledby="questionnaire-answers-title">
      <div class="modal-head">
        <h3 id="questionnaire-answers-title">Risposte questionario</h3>
        <div class="head-actions">
          <input v-model.trim="modalSearch" class="input input--compact" placeholder="Filtra campi…" aria-label="Filtra i campi del questionario" />
          <button class="btn ghost tiny" @click="closeModal">Chiudi</button>
        </div>
      </div>

      <div class="modal-scroll">
        <div class="meta">
          <div><strong>Email:</strong> <span class="mono">{{ userEmails[activeRow?.uid] || '—' }}</span></div>
          <div><strong>Prodotto:</strong> {{ activeRow?.productName || '—' }}</div>
          <div class="meta-step">
            <strong>Step:</strong>
            <span>{{ activeRow?.stepKey || '—' }}</span>
            <span v-if="stepCloneLabel(activeRow)" class="step-tag">· {{ stepCloneLabel(activeRow) }}</span>
          </div>
          <div><strong>Data:</strong> {{ formatDateTime(activeRow?.updatedAt || activeRow?.createdAt) }}</div>
          <div><strong>Sequenza:</strong>
            <template v-if="activeRow?.sequenceIndex != null">
              {{ activeRow.sequenceIndex }}<template v-if="activeRow?.sequenceTotal">/{{ activeRow.sequenceTotal }}</template>
            </template>
            <template v-else>—</template>
          </div>
          <div><strong>Stato admin:</strong> {{ adminLabel(activeRow?.adminStatus) }}</div>
          <div v-if="activeRow?.adminNote"><strong>Nota:</strong> “{{ activeRow.adminNote }}”</div>
        </div>

        <div class="answers">
          <div v-if="modalLoading" class="data-state">Caricamento dati…</div>
          <div v-else-if="modalBundleError" class="data-state error">{{ modalBundleError }}</div>
          <template v-else>
            <div v-if="modalSections.length" class="modal-sections">
              <section v-for="section in modalSections" :key="section.key" class="modal-section">
                <header class="modal-section__head">
                  <div>
                    <h4>{{ section.title }}</h4>
                    <p v-if="section.subtitle" class="modal-section__subtitle">{{ section.subtitle }}</p>
                  </div>
                  <div v-if="section.meta" class="modal-section__meta">{{ section.meta }}</div>
                </header>
                <div v-if="section.groups.length" class="modal-section__body">
                  <div
                    v-for="group in section.groups"
                    :key="group.key || group.title || group.rootLabel"
                    class="modal-group"
                  >
                    <h5 v-if="group.title" class="modal-group__title">{{ group.title }}</h5>
                    <div
                      v-for="entry in group.entries"
                      :key="entry.key"
                      class="modal-row"
                      :class="{ multiline: entry.multiline }"
                    >
                      <div class="modal-row__key mono">{{ entry.labelInGroup }}</div>
                      <div class="modal-row__value">
                        <pre v-if="entry.multiline">{{ entry.display }}</pre>
                        <span v-else>{{ entry.display }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="data-state muted">Nessun campo corrisponde al filtro.</div>
              </section>
            </div>
            <div v-else class="data-state muted">Nessun campo corrisponde al filtro.</div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import SidebarComponent from '../SidebarComponent.vue';
import {
  getFirestore,
  collection,
  query,
  onSnapshot,
  orderBy,
  doc,
  getDoc,
  updateDoc,
  getDocs,
  where,
  limit as firestoreLimit
} from 'firebase/firestore';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import {
  flattenAnswers,
  prettifyKey,
  buildQuestionarioSections,
  buildCheckFinaleSections,
} from '../../lib/questionarioDisplay.js';
import { dispatchNeedsUpdateNotification } from '../../lib/percorsoStepNotifications';
import { saveDailySend } from '@/lib/dailySend';
import { manualInstallmentStats } from '@/lib/manualInstallments';

const toDateSafe = (value) => {
  if (!value) return null;
  if (value instanceof Date && !Number.isNaN(value.getTime())) return value;
  if (value?.toDate) {
    const d = value.toDate();
    return Number.isNaN(d.getTime()) ? null : d;
  }
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
};
const isManualStandaloneFlag = (value) =>
  value === true || value === '1' || value === 1 || value === 'true';
// Flag "da rinnovare" che potrebbe essere salvato con nomi diversi
const renewalFlagKeys = ['daRinnovare', 'da_rinnovare', 'needsRenewal', 'toRenew', 'renew', 'renewal'];
const renewalAtKeys = ['daRinnovareAt', 'da_rinnovare_at', 'renewalAt', 'renewAt', 'renewedAt'];
const readRenewalFlag = (source = {}) => {
  if (!source || typeof source !== 'object') return { found: false, value: false };
  for (const key of renewalFlagKeys) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      const v = source[key];
      const normalized = v === true || v === 1 || v === '1' || v === 'true';
      return { found: true, value: normalized };
    }
  }
  return { found: false, value: false };
};
const readRenewalAt = (source = {}) => {
  if (!source || typeof source !== 'object') return null;
  for (const key of renewalAtKeys) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      const date = toDateSafe(source[key]);
      if (date) return date;
    }
  }
  return null;
};
const DEFAULT_LOOKBACK_DAYS = 30;
const DEFAULT_LOOKBACK_MS = DEFAULT_LOOKBACK_DAYS * 24 * 60 * 60 * 1000;
const CREATED_AT_MIN = new Date(Date.now() - DEFAULT_LOOKBACK_MS);
const PAYMENT_FALLBACK_WINDOW_DAYS = 14;
const PAYMENT_FALLBACK_WINDOW_MS = PAYMENT_FALLBACK_WINDOW_DAYS * 24 * 60 * 60 * 1000;
const DAILY_PRIV_UID = 'HpMiFyBZnwX6EUf6VR9iCsHkqo82';
const DAILY_PRIV_EMAIL = 'valeriobianconi@gmail.com';
export default {
  name: 'QuestionariList',
  components: { SidebarComponent },

  data() {
    return {
      // dataset
      savedQuestionari: [],
      rawFilteredData: [],
      filteredQuestionari: [],
      isLoading: true,
      questionariUnsub: null,
      currentCreatedAtMin: CREATED_AT_MIN,
      filtersOpen: false,
      mobileExpandedQuestionari: new Set(),

      // filtri
      selectedAdmin: '',
      selectedStepKey: '',
      selectedValutazione: '',
      selectedStudio: '',
      dateFrom: '',
      dateTo: '',
      showSent: false,
      showStopped: false,
      showToRenew: false,

      // cache email
      userEmails: {},                // { uid: email }
      userStudios: {},               // { uid: studio }
      fetchingUids: new Set(),
      latestOrderByEmail: {},        // { email: { order, date, time } }
      fetchingOrderEmails: new Set(),
      paymentOrdersByRef: {},        // { orderRef: { order } }
      fetchingPaymentOrderRefs: new Set(),
      paymentOrdersByEmail: {},      // { lookupKey: { orders: [] } }
      fetchingPaymentOrderEmails: new Set(),

      // cache percorsi (steps)
      percorsiCache: {},             // { percorsoId: steps[] }
      percorsoMetaCache: {},         // { percorsoId: meta }
      fetchingPercorsi: new Set(),
      duplicateUids: new Set(),

      // modale risposte
      showModal: false,
      activeRow: null,
      modalSearch: '',
      modalBundle: null,
      modalBundleError: '',
      modalLoading: false,
      bundleCache: {},

      // UI “Richiesto aggiornamento”
      needsUpdateOpen: {},           // { rowKey: bool }
      needsUpdateNotes: {},          // { rowKey: 'nota' }

      // note interne staff (per riga/step)
      staffNoteEdits: {},            // { rowKey: string }
      saveStatus: {},                // { rowKey: 'ok'|'err'|undefined }

      // invio di giornata
      savingDaily: {},               // { rowKey: bool }
      sequenceGroupCache: {},        // { groupId: percorsi[] }
      fetchingSequenceGroups: {},
      nextPercorsiCache: {},         // { cacheKey: context }
      canMarkDailyManual: false,
      authUnsub: null,
    };
  },

  mounted() {
    this.listenRT();
    this.initAuthWatcher();
  },
  beforeUnmount() {
    if (typeof this.questionariUnsub === 'function') {
      this.questionariUnsub();
    }
    if (typeof this.authUnsub === 'function') {
      this.authUnsub();
    }
  },

  computed: {
    modalSections() {
      if (!this.activeRow) return [];
      const sections = [];
      const search = this.modalSearch;
      const bundle = this.modalBundle || {};
      const activeId = this.activeRow?.id;

      const addSection = (key, title, subtitle, info, answers, typeKey) => {
        const groups = this.buildSectionGroups(typeKey, answers, search);
        if (!groups.length) return;
        sections.push({
          key,
          title,
          subtitle: subtitle || '',
          meta: info?.updatedAt
            ? `Aggiornato: ${this.formatDateTime(info.updatedAt)}`
            : info?.createdAt
            ? `Creato: ${this.formatDateTime(info.createdAt)}`
            : '',
          groups,
        });
      };

      if (bundle.questionario) {
        addSection(
          'questionario',
          'Questionario Programmi',
          bundle.questionario.templateLabel,
          bundle.questionario,
          bundle.questionario.answers,
          'questionario'
        );
      }

      if (bundle.checkFinale) {
        addSection(
          'check_finale',
          'Check Finale Programmi',
          bundle.checkFinale.templateLabel,
          bundle.checkFinale,
          bundle.checkFinale.answers,
          'check_finale'
        );
      }

      const currentIsKnown =
        (bundle.questionario && bundle.questionario.docId === activeId) ||
        (bundle.checkFinale && bundle.checkFinale.docId === activeId);

      if (!currentIsKnown) {
        const createdAt = this.activeRow?.createdAt ? new Date(this.activeRow.createdAt) : null;
        const updatedAt = this.activeRow?.updatedAt ? new Date(this.activeRow.updatedAt) : null;
        addSection(
          'current',
          this.sectionTitle(this.activeRow),
          this.sectionSubtitle(this.activeRow),
          { createdAt, updatedAt },
          this.activeRow.answers || {},
          (this.activeRow?.stepKey || '').toLowerCase()
        );
      }

      return sections;
    },

    studioOptions() {
      const opts = new Set();
      Object.values(this.userStudios || {}).forEach((studio) => {
        if (studio && studio !== '—') {
          opts.add(studio);
        }
      });
      return Array.from(opts).sort((a, b) => a.localeCompare(b));
    }
  },

  methods: {
    toggleMobileQuestionario(q) {
      const expandedQuestionari = new Set(this.mobileExpandedQuestionari);
      if (expandedQuestionari.has(q.id)) {
        expandedQuestionari.delete(q.id);
      } else {
        expandedQuestionari.add(q.id);
      }
      this.mobileExpandedQuestionari = expandedQuestionari;
    },
    updateDuplicateUids(rows) {
      const counts = new Map();
      (rows || []).forEach((row) => {
        const uid = row?.uid || null;
        if (!uid) return;
        counts.set(uid, (counts.get(uid) || 0) + 1);
      });
      const dupes = new Set([...counts.entries()].filter(([, c]) => c > 1).map(([uid]) => uid));
      this.duplicateUids = dupes;
    },
    normalizeDateLowerBound() {
      const fromDateRaw = this.dateFrom ? new Date(`${this.dateFrom}T00:00:00`) : null;
      const fromDate = fromDateRaw && !Number.isNaN(fromDateRaw.getTime()) ? fromDateRaw : null;
      return fromDate || CREATED_AT_MIN;
    },
    initAuthWatcher() {
      const auth = getAuth();
      const evaluate = (user) => {
        if (!user) {
          this.canMarkDailyManual = false;
          return;
        }
        const email = (user.email || '').toLowerCase();
        this.canMarkDailyManual =
          user.uid === DAILY_PRIV_UID || email === DAILY_PRIV_EMAIL.toLowerCase();
      };
      evaluate(auth.currentUser);
      this.authUnsub = onAuthStateChanged(auth, evaluate);
    },
    restartListenerIfNeeded() {
      const desiredMin = this.normalizeDateLowerBound();
      const currentMs = this.currentCreatedAtMin?.getTime();
      const desiredMs = desiredMin?.getTime();
      if (currentMs === desiredMs || (!Number.isFinite(currentMs) && !Number.isFinite(desiredMs))) {
        return false;
      }
      this.isLoading = true;
      this.listenRT(desiredMin);
      return true;
    },

    // ====== utility ======
    keyFor(row) {
      if (row.percorsoIdValid && row.percorsoId != null && row.stepIndex != null) {
        return `${row.percorsoId}__${row.stepIndex}`;
      }
      return `manual__${row.id}`;
    },

    normalizeEmail(value) {
      const trimmed = (value || '').toString().trim();
      return trimmed ? trimmed.toLowerCase() : '';
    },

    latestOrderEntry(row) {
      const uid = row?.uid;
      const email = (this.userEmails[uid] || '').toString().trim();
      if (!email || email === '—') return null;
      const key = this.normalizeEmail(email);
      return this.latestOrderByEmail[key] || null;
    },

    normalizeOrderRef(value) {
      const normalized = (value || '').toString().trim();
      return normalized || '';
    },

    orderRefsForRow(row) {
      const refs = [
        row?.orderRef,
        row?.orderId,
        row?.percorsoMeta?.orderRef,
        row?.stepMeta?.orderRef,
      ]
        .map((value) => this.normalizeOrderRef(value))
        .filter(Boolean);
      return Array.from(new Set(refs));
    },

    orderMatchesRef(order, ref) {
      const target = this.normalizeOrderRef(ref);
      if (!target || !order) return false;
      const candidates = [
        order.id,
        order._id,
        order.orderId,
        order.order_id,
        order.orderNumber,
        order.orderRef,
      ].map((value) => this.normalizeOrderRef(value));
      return candidates.includes(target);
    },

    primaryOrderRefForRow(row) {
      return this.orderRefsForRow(row)[0] || '';
    },

    paymentOrderRefEntry(row) {
      const ref = this.primaryOrderRefForRow(row);
      if (!ref) return { state: 'missing_ref', ref: '', entry: null };
      if (this.fetchingPaymentOrderRefs.has(ref)) return { state: 'loading', ref, entry: null };
      if (!Object.prototype.hasOwnProperty.call(this.paymentOrdersByRef, ref)) {
        return { state: 'loading', ref, entry: null };
      }
      return { state: 'ready', ref, entry: this.paymentOrdersByRef[ref] || null };
    },

    paymentLookupForRow(row) {
      const uid = (row?.uid || '').toString().trim();
      const email = this.normalizeEmail(this.userEmails[uid] || row?.userEmail || row?.email || '');
      if (uid && email) return { key: `uid:${uid}|email:${email}`, uid, email };
      if (uid) return { key: `uid:${uid}`, uid, email };
      if (email) return { key: `email:${email}`, uid: '', email };
      return { key: '', uid: '', email: '' };
    },

    paymentOrdersEntry(row) {
      const lookup = this.paymentLookupForRow(row);
      const key = lookup.key;
      if (!key) return { state: 'missing_email', key: '', entry: null };
      if (this.fetchingPaymentOrderEmails.has(key)) return { state: 'loading', key, entry: null };
      if (!Object.prototype.hasOwnProperty.call(this.paymentOrdersByEmail, key)) {
        return { state: 'loading', key, entry: null };
      }
      return { state: 'ready', key, entry: this.paymentOrdersByEmail[key] || null };
    },

    resolvePaymentOrderForRow(row, orders = []) {
      const list = Array.isArray(orders) ? orders : [];
      if (!list.length) return null;
      const refs = this.orderRefsForRow(row);
      for (const ref of refs) {
        const found = list.find((order) => this.orderMatchesRef(order, ref));
        if (found) return found;
      }
      return [...list].sort((a, b) => {
        const ta = this.parseOrderDate(a)?.getTime() || 0;
        const tb = this.parseOrderDate(b)?.getTime() || 0;
        return tb - ta;
      })[0] || null;
    },

    orderIdentity(order) {
      if (!order || typeof order !== 'object') return '';
      return this.normalizeOrderRef(
        order.id || order._id || order.orderId || order.order_id || order.orderNumber || order.orderRef
      );
    },

    orderProductNames(order) {
      if (!order || typeof order !== 'object') return [];
      const names = [];
      const pushName = (value) => {
        const normalized = this.normalizeProductName(value);
        if (normalized) names.push(normalized);
      };
      if (Array.isArray(order.products)) {
        order.products.forEach((item) => {
          pushName(item?.name || item?.title || item?.productName || item?.sku);
        });
      }
      pushName(order.productName || order.orderName || order.orderTitle || order.title || order.name);
      return Array.from(new Set(names));
    },

    rowProductNames(row) {
      if (!row || typeof row !== 'object') return [];
      const names = [
        row.productName,
        row.programTitle,
        row.percorsoMeta?.productName,
        row.percorsoMeta?.title,
        row.stepMeta?.productName,
        row.stepMeta?.title,
      ]
        .map((value) => this.normalizeProductName(value))
        .filter(Boolean);
      return Array.from(new Set(names));
    },

    productNamesMatch(a, b) {
      const left = this.normalizeProductName(a);
      const right = this.normalizeProductName(b);
      if (!left || !right) return false;
      return left === right || left.includes(right) || right.includes(left);
    },

    orderMatchesPaymentContext(row, order, referenceOrder = null) {
      const contextNames = this.rowProductNames(row);
      const referenceNames = contextNames.length ? contextNames : this.orderProductNames(referenceOrder);
      if (!referenceNames.length) return false;
      const orderNames = this.orderProductNames(order);
      if (!orderNames.length) return false;
      return referenceNames.some((referenceName) =>
        orderNames.some((orderName) => this.productNamesMatch(referenceName, orderName))
      );
    },

    isNearPaymentReference(row, order, referenceOrder = null) {
      const orderDate = this.parseOrderDate(order);
      if (!orderDate) return true;
      const referenceDates = [
        this.parseOrderDate(referenceOrder),
        toDateSafe(row?.updatedAt),
        toDateSafe(row?.createdAt),
      ].filter(Boolean);
      if (!referenceDates.length) return true;
      return referenceDates.some(
        (referenceDate) => Math.abs(orderDate.getTime() - referenceDate.getTime()) <= PAYMENT_FALLBACK_WINDOW_MS
      );
    },

    findPaidFallbackOrderForRow(row, orders = [], referenceOrder = null) {
      const referenceIdentity = this.orderIdentity(referenceOrder);
      const paidCandidates = (Array.isArray(orders) ? orders : [])
        .filter((order) => {
          if (!order || order === referenceOrder) return false;
          if (referenceIdentity && this.orderIdentity(order) === referenceIdentity) return false;
          if (!this.isOrderPaid(order)) return false;
          return this.isNearPaymentReference(row, order, referenceOrder);
        });
      const productMatched = paidCandidates.filter((order) =>
        this.orderMatchesPaymentContext(row, order, referenceOrder)
      );
      const candidates = (productMatched.length ? productMatched : paidCandidates)
        .sort((a, b) => {
          const ta = this.parseOrderDate(a)?.getTime() || 0;
          const tb = this.parseOrderDate(b)?.getTime() || 0;
          return tb - ta;
      });
      return candidates[0] || null;
    },

    assumedPaidInfoForOrder(order = null) {
      const orderLabel = order?.orderId || order?.id || '';
      return {
        label: 'Pagato',
        className: 'payment-chip--ok',
        title: orderLabel
          ? `Ordine ${orderLabel}: non ha rate manuali.`
          : 'Non ha rate manuali.',
        issue: false,
        kind: 'paid_assumed',
      };
    },

    findAssumedPaidNonManualOrderForRow(row, orders = [], referenceOrder = null) {
      const list = Array.isArray(orders) ? orders : [];
      if (referenceOrder && !this.isManualInstallmentsOrder(referenceOrder)) return referenceOrder;

      const refs = this.orderRefsForRow(row);
      const nonManual = list.filter((order) => order && !this.isManualInstallmentsOrder(order));
      if (!nonManual.length) return null;

      const exact = refs.length
        ? nonManual.find((order) => refs.some((ref) => this.orderMatchesRef(order, ref)))
        : null;
      if (exact) return exact;

      const chooseLatest = (items = []) =>
        [...items].sort((a, b) => {
          const ta = this.parseOrderDate(a)?.getTime() || 0;
          const tb = this.parseOrderDate(b)?.getTime() || 0;
          return tb - ta;
        })[0] || null;

      const productMatched = nonManual.filter((order) =>
        this.orderMatchesPaymentContext(row, order, referenceOrder)
      );
      const productAndNear = productMatched.filter((order) =>
        this.isNearPaymentReference(row, order, referenceOrder)
      );
      const near = nonManual.filter((order) =>
        this.isNearPaymentReference(row, order, referenceOrder)
      );

      return chooseLatest(productAndNear)
        || chooseLatest(productMatched)
        || chooseLatest(near)
        || (nonManual.length === 1 ? nonManual[0] : null);
    },

    findManualInstallmentsOrderForRow(row, orders = [], referenceOrder = null) {
      const list = Array.isArray(orders) ? orders : [];
      if (referenceOrder && this.isManualInstallmentsOrder(referenceOrder)) return referenceOrder;

      const refs = this.orderRefsForRow(row);
      const manualOrders = list.filter((order) => this.isManualInstallmentsOrder(order));
      if (!manualOrders.length) return null;

      const exact = refs.length
        ? manualOrders.find((order) => refs.some((ref) => this.orderMatchesRef(order, ref)))
        : null;
      if (exact) return exact;

      const chooseLatest = (items = []) =>
        [...items].sort((a, b) => {
          const ta = this.parseOrderDate(a)?.getTime() || 0;
          const tb = this.parseOrderDate(b)?.getTime() || 0;
          return tb - ta;
        })[0] || null;

      const productMatched = manualOrders.filter((order) =>
        this.orderMatchesPaymentContext(row, order, referenceOrder)
      );
      const productAndNear = productMatched.filter((order) =>
        this.isNearPaymentReference(row, order, referenceOrder)
      );
      const near = manualOrders.filter((order) =>
        this.isNearPaymentReference(row, order, referenceOrder)
      );

      return chooseLatest(productAndNear)
        || chooseLatest(productMatched)
        || chooseLatest(near)
        || (manualOrders.length === 1 ? manualOrders[0] : null);
    },

    shouldUsePaidFallback(paymentInfo, order) {
      if (!paymentInfo || !order) return false;
      if (this.isManualInstallmentsOrder(order)) {
        return ['manual_pending', 'manual_unpaid'].includes(paymentInfo.kind);
      }
      return ['pending', 'terminal_unpaid', 'unpaid'].includes(paymentInfo.kind);
    },

    normalizeOrderStatus(value) {
      return (value || '').toString().trim().toLowerCase();
    },

    isTerminalUnpaidStatus(value) {
      const normalized = this.normalizeOrderStatus(value);
      if (!normalized) return false;
      return [
        'cancell',
        'annull',
        'rimbors',
        'refund',
        'failed',
        'declined',
        'denied',
        'void',
        'expired',
        'scadut',
      ].some((needle) => normalized.includes(needle));
    },

    isPendingPaymentStatus(value) {
      const normalized = this.normalizeOrderStatus(value);
      if (!normalized) return false;
      return normalized.includes('pending')
        || normalized.includes('attesa')
        || normalized.includes('on-hold')
        || normalized.includes('waiting')
        || normalized.includes('unpaid')
        || normalized.includes('created')
        || normalized.includes('not_started')
        || normalized.includes('requires_payment')
        || normalized.includes('requires_capture')
        || normalized.includes('pagamento');
    },

    paymentInfoForOrder(order) {
      if (!order) {
        return {
          label: 'Scaduto',
          className: 'payment-chip--danger',
          title: 'Nessun ordine valido trovato per questo utente.',
          issue: true,
          kind: 'missing_order',
        };
      }

      if (this.isManualInstallmentsOrder(order)) {
        const stats = manualInstallmentStats(order.manualInstallments || [], Date.now(), order);
        if (stats.expired > 0) {
          return {
            label: 'Scaduto',
            className: 'payment-chip--danger',
            title: `${stats.expired} rate scadute su ${stats.total || 0}.`,
            issue: true,
            kind: 'manual_expired',
          };
        }
        if (stats.cancelled > 0) {
          if (stats.paid > 0) {
            return {
              label: 'Pagato',
              className: 'payment-chip--ok',
              title: `${stats.paid}/${stats.total} rate pagate; ${stats.cancelled} annullate e non dovute.`,
              issue: false,
              kind: 'manual_closed',
            };
          }
          return {
            label: 'Annullato',
            className: 'payment-chip--muted',
            title: `Ordine annullato: ${stats.cancelled}/${stats.total} rate non dovute.`,
            issue: false,
            kind: 'manual_cancelled',
          };
        }
        if (stats.total > 0 && stats.paid === stats.total) {
          return {
            label: 'Pagato',
            className: 'payment-chip--ok',
            title: `Piano saldato: ${stats.paid}/${stats.total} rate pagate.`,
            issue: false,
            kind: 'manual_ok',
          };
        }
        if (stats.total > 0 && stats.paid > 0) {
          return {
            label: 'Pagato',
            className: 'payment-chip--ok',
            title: `Rate manuali in regola: ${stats.paid}/${stats.total} pagate, ${stats.pending} in attesa, nessuna scaduta.`,
            issue: false,
            kind: 'manual_ok',
          };
        }
        if (stats.total > 0 && stats.pending > 0) {
          return {
            label: 'In attesa di pagamento',
            className: 'payment-chip--warning',
            title: `Piano rate in attesa: ${stats.pending}/${stats.total} rate non ancora pagate.`,
            issue: false,
            kind: 'manual_pending',
          };
        }
        return {
          label: 'Scaduto',
          className: 'payment-chip--danger',
          title: 'Ordine a rate manuali senza rate pagate.',
          issue: true,
          kind: 'manual_unpaid',
        };
      }

      if (this.isOrderPaid(order)) {
        return {
          label: 'Pagato',
          className: 'payment-chip--ok',
          title: `Ordine ${order.orderId || order.id || ''} pagato.`,
          issue: false,
          kind: 'paid',
        };
      }

      const status = this.normalizeOrderStatus(order.status || order.orderStatus || order.state);
      const paymentStatus = this.normalizeOrderStatus(order.paymentStatus || order.payment_status);
      if (this.isTerminalUnpaidStatus(status) || this.isTerminalUnpaidStatus(paymentStatus)) {
        return {
          label: 'Scaduto',
          className: 'payment-chip--danger',
          title: `Stato ordine: ${status || '—'} · pagamento: ${paymentStatus || '—'}.`,
          issue: true,
          kind: 'terminal_unpaid',
        };
      }
      if (this.isPendingPaymentStatus(status) || this.isPendingPaymentStatus(paymentStatus)) {
        return {
          label: 'In attesa di pagamento',
          className: 'payment-chip--warning',
          title: `Pagamento in attesa. Stato ordine: ${status || '—'} · pagamento: ${paymentStatus || '—'}.`,
          issue: false,
          kind: 'pending',
        };
      }
      return {
        label: 'Scaduto',
        className: 'payment-chip--danger',
        title: `Ordine non pagato. Stato ordine: ${status || '—'} · pagamento: ${paymentStatus || '—'}.`,
        issue: true,
        kind: 'unpaid',
      };
    },

    paymentInfoForRow(row) {
      const orderRefLookup = this.paymentOrderRefEntry(row);
      if (orderRefLookup.state === 'loading') {
        return {
          label: '…',
          className: 'payment-chip--pending',
          title: 'Controllo ordine collegato in corso.',
          issue: false,
        };
      }
      if (orderRefLookup.state === 'ready' && orderRefLookup.entry?.order) {
        const order = orderRefLookup.entry.order;
        return this.isManualInstallmentsOrder(order)
          ? this.paymentInfoForOrder(order)
          : this.assumedPaidInfoForOrder(order);
      }

      const lookup = this.paymentOrdersEntry(row);
      if (lookup.state === 'missing_email') {
        return {
          label: '—',
          className: 'payment-chip--muted',
          title: 'Email utente non disponibile.',
          issue: false,
        };
      }
      if (lookup.state === 'loading') {
        return {
          label: '…',
          className: 'payment-chip--pending',
          title: 'Controllo pagamenti in corso.',
          issue: false,
        };
      }
      const orders = Array.isArray(lookup.entry?.orders) ? lookup.entry.orders : [];
      if (!orders.length) return this.assumedPaidInfoForOrder(null);

      const referenceOrder = this.resolvePaymentOrderForRow(row, orders);
      const nonManualOrder = this.findAssumedPaidNonManualOrderForRow(row, orders, referenceOrder);
      if (nonManualOrder) return this.assumedPaidInfoForOrder(nonManualOrder);

      const manualOrder = this.findManualInstallmentsOrderForRow(row, orders, referenceOrder);
      if (manualOrder) return this.paymentInfoForOrder(manualOrder);

      return this.assumedPaidInfoForOrder(null);
    },

    paymentChipLabel(row) {
      return this.paymentInfoForRow(row).label;
    },

    paymentChipClass(row) {
      return this.paymentInfoForRow(row).className;
    },

    paymentChipTitle(row) {
      return this.paymentInfoForRow(row).title;
    },

    isPaymentIssueRow(row) {
      return this.paymentInfoForRow(row).issue === true;
    },

    renewalDateForRow(row) {
      if (!row) return null;
      if (row.renewalAt instanceof Date) return row.renewalAt;
      if (row.renewalAt) {
        const parsed = this.toDate(row.renewalAt);
        if (parsed) return parsed;
      }
      if (row.stepMeta) {
        const parsed = readRenewalAt(row.stepMeta);
        if (parsed) return parsed;
      }
      return this.completionDateForRow(row);
    },

    completionDateForRow(row) {
      if (!row) return null;
      const doneAt = toDateSafe(row.stepMeta?.doneAt);
      if (doneAt) return doneAt;
      const updatedAt = toDateSafe(row.updatedAt);
      if (updatedAt) return updatedAt;
      const createdAt = toDateSafe(row.createdAt);
      if (createdAt) return createdAt;
      return null;
    },

    isPostRenewalOrder(row, entry) {
      const renewalAt = this.renewalDateForRow(row);
      if (!renewalAt) return null;
      if (!entry?.date) return false;
      const renewalTs = renewalAt instanceof Date ? renewalAt.getTime() : this.toDate(renewalAt)?.getTime();
      const orderTs = entry.date instanceof Date ? entry.date.getTime() : this.toDate(entry.date)?.getTime();
      if (!renewalTs || !orderTs) return false;
      return orderTs >= renewalTs;
    },

    isPostRenewalPurchaseRow(row) {
      if (!this.showToRenew || !row?.needsRenewal) return false;
      const entry = this.latestOrderEntry(row);
      if (!entry?.order) return false;
      if (this.isCoachingDayOnlineOrder(entry.order)) return false;
      return this.isPostRenewalOrder(row, entry) === true;
    },

    purchaseChipLabel(row) {
      const uid = row?.uid;
      const email = (this.userEmails[uid] || '').toString().trim();
      if (!email || email === '—') return '—';
      const key = this.normalizeEmail(email);
      if (this.fetchingOrderEmails.has(key)) return '…';
      if (!(key in this.latestOrderByEmail)) return '…';
      const entry = this.latestOrderByEmail[key];
      if (!entry || !entry.order) return 'No';
      if (this.isCoachingDayOnlineOrder(entry.order)) return 'No';
      const postRenewal = this.isPostRenewalOrder(row, entry);
      if (postRenewal == null) return '—';
      return postRenewal ? 'SI' : 'No';
    },

    purchaseChipClass(row) {
      const uid = row?.uid;
      const email = (this.userEmails[uid] || '').toString().trim();
      if (!email || email === '—') return 'purchase-chip--muted';
      const key = this.normalizeEmail(email);
      if (this.fetchingOrderEmails.has(key)) return 'purchase-chip--pending';
      if (!(key in this.latestOrderByEmail)) return 'purchase-chip--pending';
      const entry = this.latestOrderByEmail[key];
      if (!entry || !entry.order) return 'purchase-chip--no';
      if (this.isCoachingDayOnlineOrder(entry.order)) return 'purchase-chip--no';
      const postRenewal = this.isPostRenewalOrder(row, entry);
      if (postRenewal == null) return 'purchase-chip--muted';
      return postRenewal ? 'purchase-chip--yes' : 'purchase-chip--no';
    },

    latestOrderProductLabel(row) {
      const entry = this.latestOrderEntry(row);
      if (!entry?.order) return '—';
      const postRenewal = this.isPostRenewalOrder(row, entry);
      if (!postRenewal) return '—';
      return this.resolveOrderProductLabel(entry.order) || '—';
    },

    latestOrderProductClass(row) {
      const entry = this.latestOrderEntry(row);
      if (!entry?.order) return '';
      const postRenewal = this.isPostRenewalOrder(row, entry);
      if (!postRenewal) return '';
      return this.isCoachingDayOnlineOrder(entry.order) ? 'purchase-product--coaching' : '';
    },

    latestOrderDateLabel(row) {
      const entry = this.latestOrderEntry(row);
      if (!entry?.date) return '—';
      const postRenewal = this.isPostRenewalOrder(row, entry);
      if (!postRenewal) return '—';
      return this.formatDate(entry.date);
    },

    normalizeProductName(value) {
      return (value || '')
        .toString()
        .trim()
        .toLowerCase()
        .replace(/\s+/g, ' ');
    },

    isCoachingDayOnlineOrder(order) {
      if (!order || typeof order !== 'object') return false;
      const target = 'coaching day online';
      const names = [];

      if (Array.isArray(order.products)) {
        order.products.forEach((item) => {
          const name = item?.name || item?.title || item?.productName || item?.sku;
          const normalized = this.normalizeProductName(name);
          if (normalized) names.push(normalized);
        });
      }

      if (!names.length) {
        const fallback = order.productName || order.orderName || order.orderTitle || order.title || order.name;
        const normalized = this.normalizeProductName(fallback);
        if (normalized) names.push(normalized);
      }

      if (!names.length) return false;
      return names.every((name) => name === target);
    },

    isCsenOrder(order) {
      if (!order || typeof order !== 'object') return false;
      const targets = new Set(['1 anno csen', '1annocsen']);
      const names = [];

      if (Array.isArray(order.products)) {
        order.products.forEach((item) => {
          const name = item?.name || item?.title || item?.productName || item?.sku;
          const normalized = this.normalizeProductName(name);
          if (normalized) names.push(normalized);
        });
      }

      if (!names.length) {
        const fallback = order.productName || order.orderName || order.orderTitle || order.title || order.name;
        const normalized = this.normalizeProductName(fallback);
        if (normalized) names.push(normalized);
      }

      if (!names.length) return false;
      return names.every((name) => {
        for (const target of targets) {
          if (name.includes(target)) return true;
        }
        return false;
      });
    },

    resolveOrderProductLabel(order) {
      if (!order || typeof order !== 'object') return '';
      const names = [];
      const pushName = (value) => {
        const label = (value || '').toString().trim();
        if (label) names.push(label);
      };
      if (Array.isArray(order.products)) {
        order.products.forEach((item) => {
          pushName(item?.name || item?.title || item?.productName || item?.sku);
        });
      }
      const unique = Array.from(new Set(names));
      if (unique.length === 1) return unique[0];
      if (unique.length > 1) return `${unique[0]} +${unique.length - 1}`;
      pushName(order.productName || order.orderName || order.orderTitle || order.title || order.name);
      return names[0] || '';
    },

    parseOrderDate(order) {
      if (!order || typeof order !== 'object') return null;
      const candidates = [
        order.orderDate,
        order.order_date,
        order.createdAt,
        order.creationDate,
        order.importedAt,
        order.updatedAt,
        order.date,
        order.timestamp,
        order.completedAt,
      ];
      for (const value of candidates) {
        const date = this.toDate(value);
        if (date) return date;
      }
      return null;
    },

    toDate(value) {
      if (!value) return null;
      if (typeof value?.toDate === 'function') {
        try { return value.toDate(); } catch { return null; }
      }
      if (typeof value === 'object' && typeof value.seconds === 'number') {
        return new Date(value.seconds * 1000);
      }
      if (typeof value === 'number') {
        const d = new Date(value);
        return Number.isNaN(d.getTime()) ? null : d;
      }
      if (typeof value === 'string') {
        const normalized = value.includes('T') ? value : value.replace(' ', 'T');
        const d = new Date(normalized);
        return Number.isNaN(d.getTime()) ? null : d;
      }
      return null;
    },

    normalizePaymentMethod(value) {
      return (value || '').toString().trim().toLowerCase().replace(/[\s-]+/g, '_');
    },

    isManualInstallmentPaid(inst) {
      if (!inst) return false;
      if (inst.paidAt) return true;
      return String(inst.status || '').trim().toLowerCase() === 'pagato';
    },

    hasPaidManualInstallments(plan = []) {
      if (!Array.isArray(plan)) return false;
      return plan.some((inst) => this.isManualInstallmentPaid(inst));
    },

    isManualInstallmentsOrder(order) {
      if (!order || typeof order !== 'object') return false;
      const method = this.normalizePaymentMethod(order.paymentMethod || order.payment_method);
      return method === 'rate_manuali'
        || (Array.isArray(order.manualInstallments) && order.manualInstallments.length > 0);
    },

    isOrderPaid(order) {
      if (!order || typeof order !== 'object') return false;
      if (order.paid === true || order.isPaid === true) return true;
      if (this.isManualInstallmentsOrder(order) && this.hasPaidManualInstallments(order.manualInstallments)) return true;

      const status = (order.status || order.orderStatus || order.state || '').toString().toLowerCase();
      const paymentStatus = (order.paymentStatus || order.payment_status || '').toString().toLowerCase();
      const provider = this.normalizePaymentMethod(
        order.paymentProvider || order.provider || order.paymentMethod || order.payment_method
      );

      const paidStatuses = new Set([
        'pagato',
        'rateizzato',
        'paid',
        'completed',
        'complete',
        'processing',
        'wc-completed',
        'wc-processing',
        'direct_purchase',
        'payment_completed',
        'completed_payment',
      ]);
      if (paidStatuses.has(status)) return true;
      if (status.startsWith('wc-') && (status.includes('completed') || status.includes('processing'))) return true;
      if (status.includes('direct') && status.includes('purchase')) return true;
      if (status.includes('payment') && status.includes('complete')) return true;

      const paidPaymentStatuses = new Set([
        'paid',
        'completed',
        'complete',
        'captured',
        'succeeded',
        'settled',
      ]);
      if (paidPaymentStatuses.has(paymentStatus)) return true;
      if (paymentStatus.includes('completed') || paymentStatus.includes('captured')) return true;

      if (provider.includes('alma')) {
        const almaStatuses = [
          order.almaPaymentState,
          order.almaPaymentStatus,
          order.almaState,
          order.almaStatus,
          order.almaProcessingStatus,
          order.alma_processing_status,
          order.alma?.state,
          order.alma?.status,
          order.alma?.processingStatus,
          order.alma?.processing_status,
          order.almaPayment?.state,
          order.almaPayment?.status,
          order.almaPayment?.processingStatus,
          order.almaPayment?.processing_status,
        ]
          .map((value) => this.normalizeOrderStatus(value))
          .filter(Boolean);
        if (almaStatuses.some((value) => paidPaymentStatuses.has(value))) return true;
        if (almaStatuses.some((value) => value.includes('completed') || value.includes('captured'))) return true;
      }

      return false;
    },

    async fetchOrdersByEmail(emails = []) {
      const normalizedSet = new Set();
      (emails || []).forEach((email) => {
        const key = this.normalizeEmail(email);
        if (!key) return;
        if (key in this.latestOrderByEmail) return;
        if (this.fetchingOrderEmails.has(key)) return;
        normalizedSet.add(key);
      });
      const normalized = Array.from(normalizedSet);

      if (!normalized.length) return;

      normalized.forEach((email) => this.fetchingOrderEmails.add(email));

      const db = getFirestore();
      const chunks = [];
      for (let i = 0; i < normalized.length; i += 10) {
        chunks.push(normalized.slice(i, i + 10));
      }

      try {
        for (const chunk of chunks) {
          const latestByEmail = {};
          chunk.forEach((email) => {
            latestByEmail[email] = null;
          });

          const applyOrdersSnap = (snap, field) => {
            snap.forEach((docSnap) => {
              const data = docSnap.data() || {};
              const orderEmail = this.normalizeEmail(data[field]);
              if (!orderEmail || !(orderEmail in latestByEmail)) return;
              if (!this.isOrderPaid(data)) return;
              if (this.isCsenOrder(data)) return;
              const date = this.parseOrderDate(data);
              const time = date ? date.getTime() : 0;
              const current = latestByEmail[orderEmail];
              if (!current || time >= current.time) {
                latestByEmail[orderEmail] = {
                  order: { id: docSnap.id, ...data },
                  date,
                  time,
                };
              }
            });
          };

          const snapUser = await getDocs(query(collection(db, 'orders'), where('userEmail', 'in', chunk)));
          applyOrdersSnap(snapUser, 'userEmail');

          const snapCustomer = await getDocs(query(collection(db, 'orders'), where('customerEmail', 'in', chunk)));
          applyOrdersSnap(snapCustomer, 'customerEmail');

          this.latestOrderByEmail = { ...this.latestOrderByEmail, ...latestByEmail };
        }
      } catch (error) {
        console.error('Errore nel recupero degli ordini:', error);
      } finally {
        normalized.forEach((email) => this.fetchingOrderEmails.delete(email));
      }
    },

    async fetchPaymentOrdersByRef(refs = []) {
      const normalizedSet = new Set();
      (refs || []).forEach((value) => {
        const ref = this.normalizeOrderRef(value);
        if (!ref) return;
        if (ref in this.paymentOrdersByRef) return;
        if (this.fetchingPaymentOrderRefs.has(ref)) return;
        normalizedSet.add(ref);
      });
      const normalized = Array.from(normalizedSet);
      if (!normalized.length) return;

      normalized.forEach((ref) => this.fetchingPaymentOrderRefs.add(ref));
      const db = getFirestore();
      const nextEntries = {};

      const resolveByQuery = async (field, value) => {
        const snap = await getDocs(
          query(collection(db, 'orders'), where(field, '==', value), firestoreLimit(1))
        );
        const first = snap.docs[0];
        return first ? { id: first.id, ...first.data() } : null;
      };

      try {
        for (const ref of normalized) {
          let order = null;
          try {
            const directSnap = await getDoc(doc(db, 'orders', ref));
            if (directSnap.exists()) {
              order = { id: directSnap.id, ...directSnap.data() };
            }
          } catch (directErr) {
            console.warn(`Lettura ordine diretto fallita per ${ref}:`, directErr);
          }

          if (!order) {
            order = await resolveByQuery('orderId', ref)
              || await resolveByQuery('orderRef', ref)
              || await resolveByQuery('orderNumber', ref);
          }

          if (!order && Number.isFinite(Number(ref))) {
            const numericRef = Number(ref);
            order = await resolveByQuery('orderId', numericRef)
              || await resolveByQuery('orderRef', numericRef)
              || await resolveByQuery('orderNumber', numericRef);
          }

          nextEntries[ref] = { order: order || null };
        }

        this.paymentOrdersByRef = { ...this.paymentOrdersByRef, ...nextEntries };
      } catch (error) {
        console.error('Errore nel recupero degli ordini collegati:', error);
      } finally {
        normalized.forEach((ref) => this.fetchingPaymentOrderRefs.delete(ref));
      }
    },

    async fetchPaymentOrdersForRows(rows = []) {
      const lookups = new Map();
      const emailToKeys = new Map();
      const uidToKeys = new Map();

      const addToMapSet = (map, value, key) => {
        if (!value || !key) return;
        const current = map.get(value) || new Set();
        current.add(key);
        map.set(value, current);
      };

      (rows || []).forEach((row) => {
        const lookup = this.paymentLookupForRow(row);
        if (!lookup.key) return;
        if (lookup.key in this.paymentOrdersByEmail) return;
        if (this.fetchingPaymentOrderEmails.has(lookup.key)) return;
        lookups.set(lookup.key, lookup);
        addToMapSet(emailToKeys, lookup.email, lookup.key);
        addToMapSet(uidToKeys, lookup.uid, lookup.key);
      });

      const keys = Array.from(lookups.keys());
      if (!keys.length) return;

      keys.forEach((key) => this.fetchingPaymentOrderEmails.add(key));

      const db = getFirestore();
      const ordersByKey = {};
      const seenByKey = {};
      keys.forEach((key) => {
        ordersByKey[key] = [];
        seenByKey[key] = new Set();
      });

      const chunksOf = (values = []) => {
        const chunks = [];
        for (let i = 0; i < values.length; i += 10) {
          chunks.push(values.slice(i, i + 10));
        }
        return chunks;
      };

      const pushOrderForKeys = (docSnap, matchingKeys) => {
        const data = docSnap.data() || {};
        if (this.isCsenOrder(data) || this.isCoachingDayOnlineOrder(data)) return;
        const docId = docSnap.id;
        matchingKeys.forEach((key) => {
          if (!ordersByKey[key]) return;
          if (seenByKey[key].has(docId)) return;
          seenByKey[key].add(docId);
          ordersByKey[key].push({ id: docId, ...data });
        });
      };

      const applyEmailSnap = (snap, field) => {
        snap.forEach((docSnap) => {
          const data = docSnap.data() || {};
          const orderEmail = this.normalizeEmail(data[field]);
          const matchingKeys = orderEmail ? emailToKeys.get(orderEmail) : null;
          if (!matchingKeys?.size) return;
          pushOrderForKeys(docSnap, matchingKeys);
        });
      };

      const applyUidSnap = (snap, field) => {
        snap.forEach((docSnap) => {
          const data = docSnap.data() || {};
          const orderUid = (data[field] || '').toString().trim();
          const matchingKeys = orderUid ? uidToKeys.get(orderUid) : null;
          if (!matchingKeys?.size) return;
          pushOrderForKeys(docSnap, matchingKeys);
        });
      };

      try {
        const emails = Array.from(emailToKeys.keys()).filter(Boolean);
        for (const chunk of chunksOf(emails)) {
          const snapUser = await getDocs(query(collection(db, 'orders'), where('userEmail', 'in', chunk)));
          applyEmailSnap(snapUser, 'userEmail');

          const snapCustomer = await getDocs(query(collection(db, 'orders'), where('customerEmail', 'in', chunk)));
          applyEmailSnap(snapCustomer, 'customerEmail');

          const snapEmail = await getDocs(query(collection(db, 'orders'), where('email', 'in', chunk)));
          applyEmailSnap(snapEmail, 'email');
        }

        const uids = Array.from(uidToKeys.keys()).filter(Boolean);
        for (const chunk of chunksOf(uids)) {
          const snapUserUid = await getDocs(query(collection(db, 'orders'), where('userUid', 'in', chunk)));
          applyUidSnap(snapUserUid, 'userUid');

          const snapUid = await getDocs(query(collection(db, 'orders'), where('uid', 'in', chunk)));
          applyUidSnap(snapUid, 'uid');

          const snapUserId = await getDocs(query(collection(db, 'orders'), where('userId', 'in', chunk)));
          applyUidSnap(snapUserId, 'userId');
        }

        const nextEntries = {};
        Object.entries(ordersByKey).forEach(([key, orders]) => {
          nextEntries[key] = {
            orders: orders.sort((a, b) => {
              const ta = this.parseOrderDate(a)?.getTime() || 0;
              const tb = this.parseOrderDate(b)?.getTime() || 0;
              return tb - ta;
            }),
          };
        });

        this.paymentOrdersByEmail = { ...this.paymentOrdersByEmail, ...nextEntries };
      } catch (error) {
        console.error('Errore nel recupero degli ordini per pagamenti:', error);
      } finally {
        keys.forEach((key) => this.fetchingPaymentOrderEmails.delete(key));
      }
    },

    queueRenewalOrderFetch(rows = []) {
      if (!this.showToRenew) return;
      const orderEmails = [];
      (rows || []).forEach((row) => {
        if (!row?.needsRenewal) return;
        const email = (this.userEmails[row.uid] || '').toString().trim();
        if (email) orderEmails.push(email);
      });
      if (orderEmails.length) {
        this.fetchOrdersByEmail(orderEmails);
      }
    },

    queuePaymentOrderFetch(rows = []) {
      const refs = [];
      const fallbackRows = [];
      (rows || []).forEach((row) => {
        const ref = this.primaryOrderRefForRow(row);
        if (ref) refs.push(ref);
        else fallbackRows.push(row);
      });
      if (refs.length) this.fetchPaymentOrdersByRef(refs);
      if (fallbackRows.length) this.fetchPaymentOrdersForRows(fallbackRows);
    },

    // i questionari manuali non hanno percorso/ordine: evitiamo di importarli
    isManualQuestionarioPayload(payload) {
      if (!payload) return false;
      if (isManualStandaloneFlag(payload.manualStandalone)) return true;
      if (payload.percorsoId) return false;
      const isZero = (value) => {
        if (value == null) return false;
        const num = Number(value);
        return !Number.isNaN(num) && num === 0;
      };

      return (payload.sequenceGroupId == null)
        && isZero(payload.sequenceIndex)
        && isZero(payload.sequenceTotal)
        && isZero(payload.stepIndex);
    },

    // colorazione riga feedback
    feedbackColor(q) {
      if (q.stepKey !== 'feedback_programmi') return '';
      const val = Number(q.answers?.valutazione);
      if ([1, 2].includes(val)) return 'fb-red';
      if (val === 3) return 'fb-orange';
      if ([4, 5].includes(val)) return 'fb-green';
      return '';
    },

    // filtro valutazione
    passValutazione(q) {
      if (!this.selectedValutazione) return true;
      const val = Number(q?.answers?.valutazione);
      if (Number.isNaN(val)) return false;
      if (this.selectedValutazione === '1-2') return val === 1 || val === 2;
      if (this.selectedValutazione === '3')   return val === 3;
      if (this.selectedValutazione === '4-5') return val === 4 || val === 5;
      return true;
    },
    shouldHideQuestionario(q) {
      if (!q) return true;
      if (isManualStandaloneFlag(q.manualStandalone)) return true;
      return q.hideFromList === true;
    },
    buildSectionGroups(typeKey, answers, searchTerm) {
      if (!answers || typeof answers !== 'object') return [];
      const normalized = (typeKey || '').toLowerCase();
      if (normalized === 'questionario' || normalized === 'user_programmi_questionario') {
        return buildQuestionarioSections(answers, searchTerm).map((section) => ({
          key: section.key,
          title: section.title,
          entries: section.entries,
        }));
      }
      if (normalized === 'check_finale' || normalized === 'user_programmi_check_finale') {
        return buildCheckFinaleSections(answers, searchTerm).map((section) => ({
          key: section.key,
          title: section.title,
          entries: section.entries,
        }));
      }
      return this.buildFallbackSections(answers, searchTerm);
    },
    buildFallbackSections(answers, searchTerm) {
      const entries = flattenAnswers(answers || {});
      const needle = (searchTerm || '').trim().toLowerCase();
      const buckets = new Map();

      entries.forEach((entry) => {
        const haystack = `${entry.label} ${entry.display}`.toLowerCase();
        if (needle && !haystack.includes(needle)) return;
        const root = entry.root;
        if (!buckets.has(root)) {
          buckets.set(root, {
            key: root,
            title: prettifyKey(root),
            entries: [],
          });
        }
        buckets.get(root).entries.push(entry);
      });

      return Array.from(buckets.values()).map((group) => {
        group.entries.sort((a, b) => a.label.localeCompare(b.label));
        return group;
      });
    },

    // ====== realtime questionari ======
    listenRT(lowerBound = CREATED_AT_MIN) {
      const db = getFirestore();
      if (typeof this.questionariUnsub === 'function') {
        this.questionariUnsub();
        this.questionariUnsub = null;
      }
      const minDate = lowerBound instanceof Date && !Number.isNaN(lowerBound.getTime())
        ? lowerBound
        : CREATED_AT_MIN;
      this.currentCreatedAtMin = minDate;

      // ordinamento dal più vecchio al più nuovo; escludiamo gli storici precedenti al bound calcolato
      const q = query(
        collection(db, 'questionari'),
        where('createdAt', '>=', minDate),
        orderBy('createdAt', 'asc')
      );
      this.questionariUnsub = onSnapshot(q, async (snap) => {
        const arr = snap.docs
          .map((d) => {
            const x = d.data() || {};
            if (this.isManualQuestionarioPayload(x)) return null;
            const percorsoIdValid = !!(x.percorsoId && Number.isInteger(x.stepIndex));
            return {
              id: d.id,
              uid: x.uid || null,
              manualStandalone: isManualStandaloneFlag(x.manualStandalone),
              percorsoId: x.percorsoId || null,
              stepIndex: Number.isInteger(x.stepIndex) ? x.stepIndex : null,
              stepKey: x.stepKey || null,
              templateId: x.templateId || null,
              templateVersion: x.templateVersion || null,
              questionarioTemplateKey: x.questionarioTemplateKey || null,
              questionarioTemplateLabel: x.questionarioTemplateLabel || null,
              productId: x.productId || null,
              productName: x.productName || null,
              orderRef: x.orderRef || x.orderId || null,
              sequenceGroupId: x.sequenceGroupId || null,
              sequenceIndex: x.sequenceIndex ?? null,
              sequenceTotal: x.sequenceTotal ?? null,
              createdAt: x.createdAt?.toDate ? x.createdAt.toDate() : (x.createdAt || null),
              updatedAt: x.updatedAt?.toDate ? x.updatedAt.toDate() : (x.updatedAt || x.updated_at || x.createdAt || null),
              importBatchId: x.importBatchId || null,
              importedAt: x.importedAt?.toDate ? x.importedAt.toDate() : (x.importedAt || null),
              answers: x.answers || {},
              importSource: (x.importSource || '').trim(),
              hideFromList: x.hideFromList === true,
              isStopped: x.stop === true || x.isStopped === true,
              needsRenewal: readRenewalFlag(x).value,
              renewalAt: readRenewalAt(x),
              // admin info (riempite da percorsi)
              adminStatus: 'none',
              adminNote: null,
              staffNote: x.staffNote || '',              // popolato da ensurePercorsiAdmin oppure dal doc manuale
              stepDone: false,
              adminDailySent: this.isDailyMarked(x),
              adminDailyState: this.normalizeAdminDailyState(x.adminDailyState, x.adminDailySent),
              adminDailySentAt: x.adminDailySentAt || x.adminDailyStateAt || null,
              percorsoIdValid,
              _saving: false,
              _savingNote: false,
              _savingStop: false,
              _savingRenewal: false
            };
          })
          .filter(Boolean);

        // percorsi cache → riempie adminStatus/adminNote/staffNote
        await this.ensurePercorsiAdmin(arr);

        const visible = arr.filter((row) => !this.shouldHideQuestionario(row));
        this.savedQuestionari = visible;
        this.rawFilteredData = [...visible];

        this.applyCombinedFilter();
        this.isLoading = false;
      }, (error) => {
        console.error('listenRT snapshot error:', error);
        this.isLoading = false;
      });
    },

    async fetchUsersEmails(uids) {
      const db = getFirestore();
      const chunks = [];
      for (let i = 0; i < uids.length; i += 10) chunks.push(uids.slice(i, i + 10));

      for (const ch of chunks) {
        const results = await Promise.all(ch.map(async (uid) => {
          try {
            const s = await getDoc(doc(db, 'users', uid));
            const d = s.exists() ? (s.data() || {}) : {};
            return {
              uid,
              email: d.email || d.userEmail || null,
              studio: d.studio || d.studioName || ''
            };
          } catch {
            return { uid, email: null, studio: '' };
          }
        }));
        const nextEmails = { ...this.userEmails };
        const nextStudios = { ...this.userStudios };
        results.forEach(({ uid, email, studio }) => {
          nextEmails[uid] = email || '—';
          nextStudios[uid] = (studio || '').trim();
          this.fetchingUids.delete(uid);
        });
        this.userEmails = nextEmails;
        this.userStudios = nextStudios;
        this.applyCombinedFilter();
      }
    },

    fetchVisibleUsersData(rowsOverride) {
      const rows = rowsOverride || this.filteredQuestionari || [];
      const missingUids = [];

      rows.forEach((row) => {
        const uid = row.uid;
        if (!uid) return;

        const hasEmail = Object.prototype.hasOwnProperty.call(this.userEmails, uid);
        const hasStudio = Object.prototype.hasOwnProperty.call(this.userStudios, uid);

        if ((!hasEmail || !hasStudio) && !this.fetchingUids.has(uid)) {
          missingUids.push(uid);
          this.fetchingUids.add(uid);
        }
      });

      if (missingUids.length) {
        this.fetchUsersEmails(missingUids);
      }
    },

    async ensurePercorsiAdmin(rows) {
      const db = getFirestore();
      const missing = new Set();
      for (const r of rows) {
        if (r.percorsoIdValid && !this.percorsiCache[r.percorsoId] && !this.fetchingPercorsi.has(r.percorsoId)) {
          missing.add(r.percorsoId);
          this.fetchingPercorsi.add(r.percorsoId);
        }
      }

      await Promise.all(Array.from(missing).map(async (pid) => {
        try {
          const s = await getDoc(doc(db, 'percorsi', pid));
          const d = s.exists() ? (s.data() || {}) : {};
          const steps = Array.isArray(d.steps) ? d.steps : [];
          const meta = {
            title: (d.title || d.productName || '').trim(),
            productName: d.productName || '',
            sequenceIndex: this.normalizeSequenceNumber(d.sequenceIndex),
            sequenceTotal: this.normalizeSequenceNumber(d.sequenceTotal),
            sequenceGroupId: d.sequenceGroupId || pid,
            orderRef: d.orderRef || null,
            importBatchId: d.importBatchId || null,
            importedAt: d.importedAt?.toDate ? d.importedAt.toDate() : (d.importedAt || null),
            importSource: (d.importSource || '').trim(),
          };
          this.percorsiCache = { ...this.percorsiCache, [pid]: steps };
          this.percorsoMetaCache = { ...this.percorsoMetaCache, [pid]: meta };
        } catch {
          this.percorsiCache = { ...this.percorsiCache, [pid]: [] };
          this.percorsoMetaCache = { ...this.percorsoMetaCache, [pid]: null };
        } finally {
          this.fetchingPercorsi.delete(pid);
        }
      }));

      // applica info admin/notes sulle righe + inizializza editor note
      const pendingNoteEdits = {};
      for (const r of rows) {
        if (!r.percorsoIdValid) continue;
        const steps = this.percorsiCache[r.percorsoId] || [];
        const st = steps[r.stepIndex] || {};
        r.adminStatus = st.adminStatus || 'none';
        r.adminNote   = st.adminNote ?? null;    // messaggio verso l'utente
        r.staffNote   = st.staffNote ?? '';      // nota interna staff
        r.stepDone    = !!st.done;
        r.adminDailyState = this.normalizeAdminDailyState(st.adminDailyState, st.adminDailySent);
        r.adminDailySent = this.isDailyMarked(st);
        r.adminDailySentAt = st.adminDailySentAt || st.adminDailyStateAt || null;
        r.stepMeta = st;
        r.isStopped = !!st.stop;
        const stepRenewal = readRenewalFlag(st);
        if (stepRenewal.found) {
          r.needsRenewal = stepRenewal.value;
        } else if (r.needsRenewal == null) {
          r.needsRenewal = false;
        }
        const stepRenewalAt = readRenewalAt(st);
        if (stepRenewalAt) {
          r.renewalAt = stepRenewalAt;
        } else if (r.percorsoIdValid) {
          r.renewalAt = null;
        }
        const percorsoMeta = this.percorsoMetaCache[r.percorsoId];
        if (percorsoMeta) {
          r.percorsoMeta = percorsoMeta;
          if (!r.sequenceGroupId && percorsoMeta.sequenceGroupId) {
            r.sequenceGroupId = percorsoMeta.sequenceGroupId;
          }
          if (r.sequenceIndex == null && percorsoMeta.sequenceIndex != null) {
            r.sequenceIndex = percorsoMeta.sequenceIndex;
          }
          if (r.sequenceTotal == null && percorsoMeta.sequenceTotal != null) {
            r.sequenceTotal = percorsoMeta.sequenceTotal;
          }
          if ((r.programTitle == null || r.programTitle === '') && percorsoMeta.title) {
            r.programTitle = percorsoMeta.title;
          }
          if (!r.importSource && percorsoMeta.importSource) {
            r.importSource = percorsoMeta.importSource;
          }
          if (!r.importBatchId && percorsoMeta.importBatchId) {
            r.importBatchId = percorsoMeta.importBatchId;
          }
          if (!r.importedAt && percorsoMeta.importedAt) {
            r.importedAt = percorsoMeta.importedAt;
          }
          if (!r.orderRef && percorsoMeta.orderRef) {
            r.orderRef = percorsoMeta.orderRef;
          }
        }
        if (!r.questionarioTemplateKey && st.questionarioTemplateKey) {
          r.questionarioTemplateKey = st.questionarioTemplateKey;
        }
        if (!r.questionarioTemplateLabel && st.questionarioTemplateLabel) {
          r.questionarioTemplateLabel = st.questionarioTemplateLabel;
        }

        const k = this.keyFor(r);
        if (this.staffNoteEdits[k] == null) {
          pendingNoteEdits[k] = r.staffNote;
        }

        // precompila eventuale nota "needs_update" nel pannello a comparsa
        if (this.needsUpdateOpen[k] && this.needsUpdateNotes[k] == null) {
          this.needsUpdateNotes[k] = r.adminNote || '';
        }
      }

      // inizializza note per i questionari manuali (senza percorso)
      rows.forEach((r) => {
        if (r.percorsoIdValid) return;
        const k = this.keyFor(r);
        if (this.staffNoteEdits[k] == null) {
          pendingNoteEdits[k] = r.staffNote || '';
        }
      });
      if (Object.keys(pendingNoteEdits).length) {
        this.staffNoteEdits = { ...this.staffNoteEdits, ...pendingNoteEdits };
      }
    },

    async getPercorsoSteps(percorsoId) {
      if (!percorsoId) return [];
      if (Object.prototype.hasOwnProperty.call(this.percorsiCache, percorsoId)) {
        const cached = this.percorsiCache[percorsoId];
        return Array.isArray(cached) ? cached : [];
      }
      try {
        const db = getFirestore();
        const snap = await getDoc(doc(db, 'percorsi', percorsoId));
        const data = snap.exists() ? (snap.data() || {}) : {};
        const steps = Array.isArray(data.steps) ? data.steps : [];
        this.percorsiCache = { ...this.percorsiCache, [percorsoId]: steps };
        if (!this.percorsoMetaCache[percorsoId]) {
          const meta = {
            title: (data.title || data.productName || '').trim(),
            productName: data.productName || '',
            sequenceIndex: this.normalizeSequenceNumber(data.sequenceIndex),
            sequenceTotal: this.normalizeSequenceNumber(data.sequenceTotal),
            sequenceGroupId: data.sequenceGroupId || percorsoId,
            orderRef: data.orderRef || null,
            importBatchId: data.importBatchId || null,
            importedAt: data.importedAt?.toDate ? data.importedAt.toDate() : (data.importedAt || null),
            importSource: (data.importSource || '').trim(),
          };
          this.percorsoMetaCache = { ...this.percorsoMetaCache, [percorsoId]: meta };
        }
        return steps;
      } catch (error) {
        console.warn('getPercorsoSteps error:', error);
        this.percorsiCache = { ...this.percorsiCache, [percorsoId]: [] };
        return [];
      }
    },

    // ====== salvataggio nota interna staff ======
    async saveStaffNote(row) {
      const k = this.keyFor(row);
      const note = (this.staffNoteEdits[k] || '').trim();

      try {
        row._savingNote = true;
        const db = getFirestore();

        if (row.percorsoIdValid) {
          const ref = doc(db, 'percorsi', row.percorsoId);

          // aggiorna solo lo step interessato
          const steps = Array.isArray(this.percorsiCache[row.percorsoId]) ? [...this.percorsiCache[row.percorsoId]] : [];
          const prev  = steps[row.stepIndex] || {};
          steps[row.stepIndex] = {
            ...prev,
            staffNote: note || null,
            adminUpdatedAt: new Date().toISOString()
          };

          await updateDoc(ref, { steps });
          this.percorsiCache = { ...this.percorsiCache, [row.percorsoId]: steps };
        } else {
          const ref = doc(db, 'questionari', row.id);
          await updateDoc(ref, {
            staffNote: note || null,
            adminUpdatedAt: new Date().toISOString()
          });
        }

        // sync locale
        row.staffNote = note || '';
        this.saveStatus = { ...this.saveStatus, [k]: 'ok' };
      } catch (e) {
        console.error('saveStaffNote error:', e);
        this.saveStatus = { ...this.saveStatus, [k]: 'err' };
        alert('Errore nel salvataggio della nota interna.');
      } finally {
        row._savingNote = false;
      }
    },

    // ====== filtri ======
    resetFilters() {
      this.selectedAdmin = '';
      this.selectedStepKey = '';
      this.selectedValutazione = '';
      this.selectedStudio = '';
      this.dateFrom = '';
      this.dateTo = '';
      this.showSent = false;
      this.showStopped = false;
      this.showToRenew = false;
      this.applyCombinedFilter();
    },

    toggleShowSent() {
      this.showSent = !this.showSent;
      this.applyCombinedFilter();
    },

    async toggleStop(row) {
      if (!row || !row.id) return;
      const prevIsStopped = !!row.isStopped;
      const next = !prevIsStopped;
      const syncLocalStopState = (isStopped, savingFlag) => {
        const updateEntry = (list) =>
          (list || []).map((item) =>
            item.id === row.id ? { ...item, isStopped, _savingStop: !!savingFlag } : item
          );
        this.savedQuestionari = updateEntry(this.savedQuestionari);
        this.rawFilteredData = updateEntry(this.rawFilteredData);
      };

      row._savingStop = true;
      syncLocalStopState(prevIsStopped, true);
      try {
        const db = getFirestore();
        if (row.percorsoIdValid) {
          // aggiorna lo step del percorso (come Approva/Disapprova)
          const ref = doc(db, 'percorsi', row.percorsoId);
          const steps = Array.isArray(this.percorsiCache[row.percorsoId]) ? [...this.percorsiCache[row.percorsoId]] : [];
          const prev = steps[row.stepIndex] || {};
          steps[row.stepIndex] = { ...prev, stop: next, adminUpdatedAt: new Date().toISOString() };
          await updateDoc(ref, { steps });
          this.percorsiCache = { ...this.percorsiCache, [row.percorsoId]: steps };
        } else {
          await updateDoc(doc(db, 'questionari', row.id), { stop: next });
        }

        row.isStopped = next;
        syncLocalStopState(next, true);
      } catch (error) {
        row.isStopped = prevIsStopped;
        console.error('toggleStop error:', error);
        alert("Errore durante l'aggiornamento dello stato Stop.");
      } finally {
        row._savingStop = false;
        syncLocalStopState(row.isStopped, false);
        this.applyCombinedFilter();
      }
    },

    async toggleRenewal(row) {
      if (!row || !row.id) return;
      const prev = !!row.needsRenewal;
      const next = !prev;
      const renewalAt = next ? new Date() : null;
      const renewalAtIso = renewalAt ? renewalAt.toISOString() : null;
      const syncLocalRenewalState = (needsRenewal, savingFlag, renewalDate) => {
        const updateEntry = (list) =>
          (list || []).map((item) =>
            item.id === row.id
              ? { ...item, needsRenewal, renewalAt: renewalDate, _savingRenewal: !!savingFlag }
              : item
          );
        this.savedQuestionari = updateEntry(this.savedQuestionari);
        this.rawFilteredData = updateEntry(this.rawFilteredData);
      };

      row._savingRenewal = true;
      syncLocalRenewalState(prev, true, row.renewalAt || null);
      try {
        const db = getFirestore();
        if (row.percorsoIdValid) {
          const ref = doc(db, 'percorsi', row.percorsoId);
          const steps = Array.isArray(this.percorsiCache[row.percorsoId]) ? [...this.percorsiCache[row.percorsoId]] : [];
          const prevStep = steps[row.stepIndex] || {};
          steps[row.stepIndex] = {
            ...prevStep,
            daRinnovare: next,
            da_rinnovare: next,
            daRinnovareAt: renewalAtIso,
            da_rinnovare_at: renewalAtIso,
            renewalAt: renewalAtIso,
            adminUpdatedAt: new Date().toISOString()
          };
          await updateDoc(ref, { steps });
          this.percorsiCache = { ...this.percorsiCache, [row.percorsoId]: steps };
        } else {
          await updateDoc(doc(db, 'questionari', row.id), {
            daRinnovare: next,
            da_rinnovare: next,
            daRinnovareAt: renewalAtIso,
            da_rinnovare_at: renewalAtIso,
            renewalAt: renewalAtIso,
            adminUpdatedAt: new Date().toISOString()
          });
        }

        row.needsRenewal = next;
        row.renewalAt = renewalAt;
        syncLocalRenewalState(next, true, renewalAt);
      } catch (error) {
        row.needsRenewal = prev;
        console.error('toggleRenewal error:', error);
        alert("Errore durante l'aggiornamento dello stato di rinnovo.");
      } finally {
        row._savingRenewal = false;
        syncLocalRenewalState(row.needsRenewal, false, row.renewalAt || null);
        this.applyCombinedFilter();
      }
    },

    toggleShowStopped() {
      this.showStopped = !this.showStopped;
      this.applyCombinedFilter();
    },

    toggleShowToRenew() {
      this.showToRenew = !this.showToRenew;
      this.applyCombinedFilter();
    },

    applyCombinedFilter() {
      const fromDateRaw = this.dateFrom ? new Date(`${this.dateFrom}T00:00:00`) : null;
      const toDateRaw = this.dateTo ? new Date(`${this.dateTo}T23:59:59.999`) : null;
      const fromDate = fromDateRaw && !Number.isNaN(fromDateRaw.getTime()) ? fromDateRaw : null;
      const toDate = toDateRaw && !Number.isNaN(toDateRaw.getTime()) ? toDateRaw : null;

      const includeSent = this.showSent;

      const passAdmin = (q) => {
        const status = q.adminStatus || 'none';
        if (!this.selectedAdmin) return true;
        if (this.selectedAdmin === 'needs_update') return status === 'needs_update';
        if (this.selectedAdmin === 'updated') return status === 'updated';
        if (this.selectedAdmin === 'todo') {
          return status === 'none' || status === 'updated' || status === 'needs_update';
        }
        if (this.selectedAdmin === 'none') return status === 'none';
        return true;
      };

      const passStep = (q) => !this.selectedStepKey || q.stepKey === this.selectedStepKey;
      const passStudio = (q) => {
        if (!this.selectedStudio) return true;
        return (this.userStudios[q.uid] || '') === this.selectedStudio;
      };
      const passDone = (q) => {
        if (!q.percorsoIdValid) return true;
        return !!q.stepDone;
      };
      const passDate = (q) => {
        if (!fromDate && !toDate) return true;
        const effectiveDate = toDateSafe(q.updatedAt || q.createdAt);
        if (!effectiveDate) return false;
        if (fromDate && effectiveDate < fromDate) return false;
        if (toDate && effectiveDate > toDate) return false;
        return true;
      };
      const passSent = (q) => includeSent || !this.isDailyMarked(q);
      const passStopped = (q) => {
        if (this.showStopped) return !!q.isStopped;
        return !q.isStopped;
      };
      const passRenewal = (q) => {
        if (this.showToRenew) return !!q.needsRenewal;
        return !q.needsRenewal;
      };

      // Se cambia il bound di createdAt, riavvia il listener e aspetta i dati corretti
      if (this.restartListenerIfNeeded()) {
        return;
      }

      const baseFiltered = (this.rawFilteredData || []).filter(
        q => !this.shouldHideQuestionario(q)
          && passAdmin(q)
          && passStep(q)
          && this.passValutazione(q)
          && passDate(q)
          && passDone(q)
          && passSent(q)
          && passStopped(q)
          && passRenewal(q)
      );

      const filteredWithStudio = this.selectedStudio
        ? baseFiltered.filter(passStudio)
        : baseFiltered;

      const sorted = [...filteredWithStudio].sort((a, b) => {
        const ta = toDateSafe(a.updatedAt || a.createdAt)?.getTime() || 0;
        const tb = toDateSafe(b.updatedAt || b.createdAt)?.getTime() || 0;
        return ta - tb; // più vecchi in alto (in base all'ultima modifica)
      });

      // mantieni vicini i duplicati: riordina per uid mantenendo l'ordine cronologico
      const grouped = [];
      const byUid = new Map();
      sorted.forEach((row) => {
        const uid = row.uid || '';
        if (!byUid.has(uid)) byUid.set(uid, []);
        byUid.get(uid).push(row);
      });
      byUid.forEach((list) => grouped.push(...list));

      this.filteredQuestionari = grouped;
      this.updateDuplicateUids(grouped);
      this.queueRenewalOrderFetch(grouped);
      this.queuePaymentOrderFetch(grouped);

      const rowsToFetch = this.selectedStudio ? baseFiltered : filteredWithStudio;
      this.fetchVisibleUsersData(rowsToFetch);
    },

    // ====== azioni admin (uguali a PercorsiUtente) ======
    async toggleAdminApproved(row) {
      if (!row.percorsoIdValid) return;
      try {
        row._saving = true;
        const db = getFirestore();
        const ref = doc(db, 'percorsi', row.percorsoId);

        const steps = Array.isArray(this.percorsiCache[row.percorsoId]) ? [...this.percorsiCache[row.percorsoId]] : [];
        const prev = steps[row.stepIndex] || {};
        const nextApproved = row.adminStatus !== 'approved';
        steps[row.stepIndex] = {
          ...prev,
          adminStatus: nextApproved ? 'approved' : 'none',
          adminNote: null,
          adminUpdatedAt: new Date().toISOString()
        };

        await updateDoc(ref, { steps });
        this.percorsiCache = { ...this.percorsiCache, [row.percorsoId]: steps };

        row.adminStatus = nextApproved ? 'approved' : 'none';
        row.adminNote = null;

        this.applyCombinedFilter();
      } catch (e) {
        console.error('toggleAdminApproved error:', e);
        alert('Errore nel salvataggio dello stato admin.');
      } finally {
        row._saving = false;
      }
    },

    toggleNeedsUpdateUI(row) {
      const k = this.keyFor(row);
      this.$set ? this.$set(this.needsUpdateOpen, k, !this.needsUpdateOpen[k])
                : (this.needsUpdateOpen = { ...this.needsUpdateOpen, [k]: !this.needsUpdateOpen[k] });

      if (this.needsUpdateOpen[k] && this.needsUpdateNotes[k] == null) {
        this.needsUpdateNotes[k] = row.adminNote || '';
      }
    },

    async saveNeedsUpdate(row) {
      if (!row.percorsoIdValid) return;
      const k = this.keyFor(row);
      const note = (this.needsUpdateNotes[k] || '').trim();

      try {
        row._saving = true;
        const db = getFirestore();
        const ref = doc(db, 'percorsi', row.percorsoId);

        const steps = Array.isArray(this.percorsiCache[row.percorsoId]) ? [...this.percorsiCache[row.percorsoId]] : [];
        const prev = steps[row.stepIndex] || {};
        const nextStep = {
          ...prev,
          adminStatus: 'needs_update',
          adminNote: note || null,
          adminUpdatedAt: new Date().toISOString()
        };
        steps[row.stepIndex] = nextStep;

        await updateDoc(ref, { steps });
        this.percorsiCache = { ...this.percorsiCache, [row.percorsoId]: steps };

        row.adminStatus = 'needs_update';
        row.adminNote = note || null;

        if (row.uid) {
          try {
            await dispatchNeedsUpdateNotification({
              db,
              userUid: row.uid,
              programId: row.percorsoId,
              stepKey: row.stepKey,
              step: nextStep,
              stepIndex: row.stepIndex,
              adminNote: note,
              notifyUser: true,
              preserveOpenStatus: true,
              awaitNotification: false,
            });
          } catch (notifyErr) {
            console.error('dispatchNeedsUpdateNotification error', notifyErr);
          }
        }

        this.needsUpdateOpen[k] = false;
        this.applyCombinedFilter();
      } catch (e) {
        console.error('saveNeedsUpdate error:', e);
        alert('Errore nel salvataggio della richiesta di aggiornamento.');
      } finally {
        row._saving = false;
      }
    },

    canShowDailySend(row) {
      return this.isDailyEligible(row) && row.adminStatus === 'approved' && !this.isFinalCheckDeliveryBlocked(row);
    },
    canShowDailyHide(row) {
      return this.canMarkDailyManual && this.isDailyEligible(row);
    },
    isDailyEligible(row) {
      if (!row) return false;
      const key = (row.stepKey || '').toLowerCase();
      return key === 'questionario' || key === 'check_finale';
    },
    normalizeSequenceNumber(value) {
      const num = Number(value);
      return Number.isFinite(num) ? num : null;
    },
    nextSequenceIndex(row) {
      const sourceIndex = row?.sequenceIndex != null ? row.sequenceIndex : row?.percorsoMeta?.sequenceIndex;
      const current = this.normalizeSequenceNumber(sourceIndex);
      if (current == null) return null;
      const sourceTotal = row?.sequenceTotal != null ? row.sequenceTotal : row?.percorsoMeta?.sequenceTotal;
      const total = this.normalizeSequenceNumber(sourceTotal);
      const next = current + 1;
      if (total != null && next > total) return null;
      return next;
    },
    buildBaseProgramContext(row) {
      if (!row) return null;
      const meta = row.percorsoMeta || this.percorsoMetaCache[row.percorsoId];
      const normalizedTitle = meta?.title?.trim()
        || (row.programTitle || row.programLabel || row.productName || '').trim();
      return {
        id: row.percorsoId || null,
        title: normalizedTitle || null,
        sequenceIndex:
          this.normalizeSequenceNumber(meta?.sequenceIndex ?? row.sequenceIndex),
        sequenceTotal:
          this.normalizeSequenceNumber(meta?.sequenceTotal ?? row.sequenceTotal),
        sequenceGroupId: meta?.sequenceGroupId || row.sequenceGroupId || (row.percorsoId || null),
      };
    },
    shouldSendToNextProgram(row) {
      if (!row || !row.percorsoIdValid) return false;
      const key = (row.stepKey || '').toLowerCase();
      if (key !== 'check_finale') return false;
      if (row.stepMeta && row.stepMeta.convertedFromQuestionario) return false;
      return true;
    },
    isImportedRow(row) {
      if (!row) return false;
      return !!(
        row.importSource ||
        row.importBatchId ||
        row.importedAt ||
        row?.percorsoMeta?.importSource ||
        row?.percorsoMeta?.importBatchId ||
        row?.percorsoMeta?.importedAt
      );
    },
    isFinalCheckDeliveryBlocked(row) {
      if (!this.shouldSendToNextProgram(row)) return false;
      if (this.isImportedRow(row)) return false;
      const baseContext = this.buildBaseProgramContext(row);
      const currentIndex = this.normalizeSequenceNumber(baseContext?.sequenceIndex);
      const total = this.normalizeSequenceNumber(baseContext?.sequenceTotal);
      if (currentIndex == null || total == null) return false;
      return currentIndex >= total;
    },
    async ensureSequenceGroupLoaded(groupId) {
      if (!groupId) return;
      if (this.sequenceGroupCache[groupId]) return;
      if (this.fetchingSequenceGroups[groupId]) {
        await this.fetchingSequenceGroups[groupId];
        return;
      }

      const loader = (async () => {
        try {
          const db = getFirestore();
          const q = query(collection(db, 'percorsi'), where('sequenceGroupId', '==', groupId));
          const snap = await getDocs(q);
          const list = snap.docs.map((docSnap) => {
            const data = docSnap.data() || {};
            return {
              id: docSnap.id,
              title: data.title || data.productName || '',
              productName: data.productName || '',
              sequenceIndex: this.normalizeSequenceNumber(data.sequenceIndex),
              sequenceTotal: this.normalizeSequenceNumber(data.sequenceTotal),
            };
          });
          this.sequenceGroupCache = { ...this.sequenceGroupCache, [groupId]: list };
        } catch (error) {
          console.error(`Errore caricando i percorsi per il gruppo ${groupId}:`, error);
          this.sequenceGroupCache = { ...this.sequenceGroupCache, [groupId]: [] };
        } finally {
          const remaining = { ...this.fetchingSequenceGroups };
          delete remaining[groupId];
          this.fetchingSequenceGroups = remaining;
        }
      })();

      this.fetchingSequenceGroups = { ...this.fetchingSequenceGroups, [groupId]: loader };
      await loader;
    },
    async resolveNextPercorsoContext(row) {
      if (!row) return null;
      const baseContext = this.buildBaseProgramContext(row);
      const groupId =
        row.sequenceGroupId ||
        baseContext?.sequenceGroupId ||
        row?.percorsoMeta?.sequenceGroupId ||
        row.percorsoId;
      const nextIndex = this.nextSequenceIndex(row);
      if (!groupId || nextIndex == null) return null;
      const cacheKey = `${groupId}__${nextIndex}`;
      if (this.nextPercorsiCache[cacheKey]) {
        return this.nextPercorsiCache[cacheKey];
      }
      await this.ensureSequenceGroupLoaded(groupId);
      const list = this.sequenceGroupCache[groupId] || [];
      const found = list.find((item) => item.sequenceIndex === nextIndex) || null;
      if (found) {
        this.nextPercorsiCache = { ...this.nextPercorsiCache, [cacheKey]: found };
      }
      return found;
    },
    async resolveDeliveryProgram(row) {
      const baseContext = this.buildBaseProgramContext(row);
      if (!this.shouldSendToNextProgram(row)) {
        return baseContext;
      }
      const next = await this.resolveNextPercorsoContext(row);
      if (next) {
        const normalizedTitle = (next.title || next.productName || '').trim();
        return {
          id: next.id || null,
          title: normalizedTitle || (baseContext ? baseContext.title : null),
          sequenceIndex: this.normalizeSequenceNumber(next.sequenceIndex),
          sequenceTotal: this.normalizeSequenceNumber(
            next.sequenceTotal ?? (baseContext ? baseContext.sequenceTotal : null)
          ),
        };
      }
      return baseContext;
    },
    setSavingDailyState(key, value) {
      if (this.$set) {
        this.$set(this.savingDaily, key, value);
      } else {
        this.savingDaily = { ...this.savingDaily, [key]: value };
      }
    },
    normalizeAdminDailyState(rawState, sentFlag = false) {
      const state = String(rawState || '').trim().toLowerCase();
      if (state === 'inviato' || state === 'nascosto') return state;
      return sentFlag ? 'inviato' : '';
    },
    isDailyMarked(row) {
      if (!row) return false;
      const state = this.normalizeAdminDailyState(row.adminDailyState, row.adminDailySent);
      return state === 'inviato' || state === 'nascosto';
    },
    dailySentChipLabel(row) {
      const state = this.normalizeAdminDailyState(row?.adminDailyState, row?.adminDailySent);
      if (state === 'nascosto') return 'Nascosto';
      return this.isToday(row?.adminDailySentAt) ? 'Inviato oggi' : 'Inviato';
    },
    dailySentChipClass(row) {
      const state = this.normalizeAdminDailyState(row?.adminDailyState, row?.adminDailySent);
      return state === 'nascosto' ? 'chip-neutral' : 'chip-blue';
    },
    async setAdminDailySent(row, mode = 'inviato') {
      if (!row.percorsoIdValid) return;
      const db = getFirestore();
      const ref = doc(db, 'percorsi', row.percorsoId);
      const steps = Array.isArray(this.percorsiCache[row.percorsoId]) ? [...this.percorsiCache[row.percorsoId]] : [];
      const prev = steps[row.stepIndex] || {};
      const normalizedMode = this.normalizeAdminDailyState(mode, true) || 'inviato';
      const adminDailySentAt = new Date().toISOString();
      steps[row.stepIndex] = {
        ...prev,
        adminDailySent: true,
        adminDailySentAt,
        adminDailyState: normalizedMode,
        adminDailyStateAt: adminDailySentAt,
        adminUpdatedAt: new Date().toISOString()
      };
      await updateDoc(ref, { steps });
      this.percorsiCache = { ...this.percorsiCache, [row.percorsoId]: steps };
      row.adminDailyState = normalizedMode;
      row.adminDailySent = true;
      row.adminDailySentAt = adminDailySentAt;
    },
    async markDailySend(row) {
      if (!row.percorsoIdValid || !this.isDailyEligible(row)) return;
      if (this.isFinalCheckDeliveryBlocked(row)) {
        alert('Invio non disponibile sul check finale dell’ultimo programma.');
        return;
      }
      if (!row.uid) {
        alert('ID utente non valido per registrare l’invio di giornata.');
        return;
      }
      const confirmMessage = 'Sei sicuro di voler procedere all\'invio?';
      if (typeof window !== 'undefined' && !window.confirm(confirmMessage)) return;

      const key = this.keyFor(row);
      this.setSavingDailyState(key, true);
      try {
        const baseContext = this.buildBaseProgramContext(row);
        const deliveryContext = await this.resolveDeliveryProgram(row);
        const normalizedStepKey = (row.stepKey || '').toLowerCase();
        await saveDailySend({
          userId: row.uid,
          percorsoId: deliveryContext?.id || row.percorsoId,
          percorsoTitle:
            deliveryContext?.title ||
            row.programTitle ||
            row.programLabel ||
            row.productName ||
            '',
          percorsoSequenceIndex:
            this.normalizeSequenceNumber(deliveryContext?.sequenceIndex) ??
            this.normalizeSequenceNumber(row.sequenceIndex) ??
            null,
          percorsoSequenceTotal:
            this.normalizeSequenceNumber(deliveryContext?.sequenceTotal) ??
            this.normalizeSequenceNumber(row.sequenceTotal) ??
            null,
          stepKey: normalizedStepKey || null,
          stepIndex: row.stepIndex,
          stepLabel: normalizedStepKey === 'check_finale' ? 'check' : normalizedStepKey,
          stepSequenceIndex:
            this.normalizeSequenceNumber(baseContext?.sequenceIndex) ??
            this.normalizeSequenceNumber(row.sequenceIndex) ??
            null,
          stepSequenceTotal:
            this.normalizeSequenceNumber(baseContext?.sequenceTotal) ??
            this.normalizeSequenceNumber(row.sequenceTotal) ??
            null,
        });
        await this.setAdminDailySent(row, 'inviato');
        // Il promemoria consulenza viene gestito dal server dopo la consegna effettiva.
        alert('Invio di giornata salvato e registrato.');
      } catch (error) {
        console.error('markDailySend error:', error);
        alert('Errore nel salvataggio dell’invio di giornata.');
      } finally {
        this.setSavingDailyState(key, false);
      }
    },
    async markDailyFlagOnly(row) {
      if (!this.canMarkDailyManual || !row?.percorsoIdValid || !this.isDailyEligible(row)) return;
      const key = this.keyFor(row);
      this.setSavingDailyState(key, true);
      try {
        await this.setAdminDailySent(row, 'nascosto');
        alert('Segnato come nascosto (senza invio).');
      } catch (error) {
        console.error('markDailyFlagOnly error:', error);
        alert('Errore nel salvataggio dello stato nascosto.');
      } finally {
        this.setSavingDailyState(key, false);
      }
    },

    // ====== azioni UI ======
    openAnswers(row) {
      this.activeRow = row;
      this.modalSearch = '';
      this.modalBundle = null;
      this.modalBundleError = '';
      this.showModal = true;
      this.prepareModalBundle(row);
    },
    handleQuestionarioClick(row) {
      if (!this.openQuestionarioPage(row)) {
        this.openAnswers(row);
      }
    },
    questionarioLinkLabel(row) {
      const target = this.resolveQuestionarioPath(row);
      if (target === 'check-finale') return 'Apri check finale';
      if (target === 'questionario') return 'Apri questionario';
      return 'Apri risposte';
    },
    resolveQuestionarioPath(row) {
      if (!row) return null;
      const typeKey = (row.type || '').toLowerCase();
      const stepKey = (row.stepKey || '').toLowerCase();
      if (typeKey === 'user_programmi_check_finale' || stepKey === 'check_finale') {
        return 'check-finale';
      }
      if (typeKey === 'user_programmi_questionario' || stepKey === 'questionario') {
        return 'questionario';
      }
      return null;
    },
    resolveQuestionarioRouteName(row) {
      const target = this.resolveQuestionarioPath(row);
      if (target === 'check-finale') return 'UserProgrammiCheckFinale';
      if (target === 'questionario') return 'UserProgrammiQuestionario';
      return null;
    },
    buildQuestionarioQuery(row) {
      const query = {};
      if (!row) return query;
      const assign = (key, value) => {
        if (value === undefined || value === null) return;
        const str = typeof value === 'string' ? value.trim() : String(value);
        if (str) query[key] = str;
      };
      assign('percorsoId', row.percorsoId);
      assign('stepIndex', row.stepIndex);
      assign('stepKey', row.stepKey);
      assign('sequenceGroupId', row.sequenceGroupId);
      assign('sequenceIndex', row.sequenceIndex);
      assign('sequenceTotal', row.sequenceTotal);
      assign('productId', row.productId);
      assign('productName', row.productName);
      assign('programTitle', row.programTitle || row.programLabel);
      assign('programLabel', row.programLabel || row.programTitle);
      assign('plannedStartAt', row.plannedStartAt);
      assign('expireAt', row.expireAt);
      assign('stepName', row.stepName);
      assign('questionarioDocId', row.id);
      return query;
    },
    stringifyQueryParams(query) {
      const entries = Object.entries(query || {}).filter(([, value]) => value !== undefined && value !== null && value !== '');
      if (!entries.length) return '';
      if (typeof URLSearchParams !== 'undefined') {
        const usp = new URLSearchParams();
        entries.forEach(([key, value]) => usp.append(key, value));
        return usp.toString();
      }
      return entries.map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join('&');
    },
    openQuestionarioPage(row) {
      if (typeof window === 'undefined') return false;
      if (!row || !row.uid) return false;
      const routeName = this.resolveQuestionarioRouteName(row);
      const query = this.buildQuestionarioQuery(row);
      let href = '';

      if (routeName && this.$router && typeof this.$router.resolve === 'function') {
        const location = this.$router.resolve({
          name: routeName,
          params: { userId: row.uid },
          query,
        });
        href = location?.href || '';
      }

      if (!href) {
        const targetPath = this.resolveQuestionarioPath(row);
        if (!targetPath) return false;
        const queryString = this.stringifyQueryParams(query);
        href = `#/user/${row.uid}/programmi/${targetPath}${queryString ? `?${queryString}` : ''}`;
      }

      let targetHref = href;
      if (!/^https?:/i.test(targetHref || '')) {
        if (targetHref.startsWith('/#/')) {
          targetHref = targetHref.substring(1);
        } else if (targetHref.startsWith('/')) {
          targetHref = `#${targetHref}`;
        } else if (!targetHref.startsWith('#')) {
          targetHref = `#/${targetHref.replace(/^#?/, '')}`;
        }
      }
      window.open(targetHref, '_blank', 'noopener');
      return true;
    },
    closeModal() {
      this.showModal = false;
      this.activeRow = null;
      this.modalSearch = '';
      this.modalBundle = null;
      this.modalBundleError = '';
      this.modalLoading = false;
    },
    async prepareModalBundle(row) {
      if (!row || !row.uid) {
        this.modalBundle = { questionario: null, checkFinale: null };
        this.modalBundleError = row ? 'Utente non disponibile.' : '';
        this.modalLoading = false;
        return;
      }

      const cacheKey = `${row.uid}__${row.percorsoId || 'nopercorso'}`;
      if (this.bundleCache[cacheKey]) {
        this.modalBundle = this.bundleCache[cacheKey];
        return;
      }

      this.modalLoading = true;
      this.modalBundleError = '';

      try {
        const db = getFirestore();
        const constraints = [where('uid', '==', row.uid)];
        if (row.percorsoId) constraints.push(where('percorsoId', '==', row.percorsoId));

        const snap = await getDocs(query(collection(db, 'questionari'), ...constraints));
        const bundle = { questionario: null, checkFinale: null };

        const assignIfNewer = (targetKey, payload) => {
          const current = bundle[targetKey];
          if (!current) {
            bundle[targetKey] = payload;
            return;
          }
          const currentTime = (current.updatedAt || current.createdAt || new Date(0)).getTime();
          const nextTime = (payload.updatedAt || payload.createdAt || new Date(0)).getTime();
          if (nextTime >= currentTime) {
            bundle[targetKey] = payload;
          }
        };

        snap.forEach((docSnap) => {
          const data = docSnap.data() || {};
          const base = {
            docId: docSnap.id,
            answers: data.answers || {},
            templateLabel:
              data.templateLabel ||
              data.questionarioTemplateLabel ||
              data.questionarioTemplate ||
              '',
            createdAt: toDateSafe(data.createdAt || data.created_at || null),
            updatedAt: toDateSafe(data.updatedAt || data.updated_at || data.createdAt || null),
            stepKey: data.stepKey || null,
            type: data.type || null,
          };

          const typeKey = (base.type || '').toLowerCase();
          const stepKey = (base.stepKey || '').toLowerCase();

          if (typeKey === 'user_programmi_questionario' || stepKey === 'questionario') {
            assignIfNewer('questionario', base);
          } else if (typeKey === 'user_programmi_check_finale' || stepKey === 'check_finale') {
            assignIfNewer('checkFinale', base);
          }
        });

        this.bundleCache = { ...this.bundleCache, [cacheKey]: bundle };
        this.modalBundle = bundle;
      } catch (error) {
        console.error('Errore caricando i questionari correlati:', error);
        this.modalBundleError = 'Impossibile recuperare tutti i dati salvati.';
        this.modalBundle = { questionario: null, checkFinale: null };
      } finally {
        this.modalLoading = false;
      }
    },
    gotoUser(uid) {
      if (!uid) return;
      window.open(`#/user/${uid}/anagrafica`, '_blank');
    },

    // ====== util ======
    adminLabel(s) {
      const v = s || 'none';
      if (v === 'approved') return 'Approvato';
      if (v === 'needs_update') return 'Richiesto aggiornamento';
      if (v === 'updated') return 'Aggiornato';
      return '—';
    },
    adminChipClass(s) {
      const v = s || 'none';
      return {
        'chip-green': v === 'approved',
        'chip-orange': v === 'needs_update',
        'chip-blue': v === 'updated',
        'chip-neutral': v === 'none'
      };
    },

    stepCloneLabel(row) {
      if (!row) return '';
      const key = (row.stepKey || '').toLowerCase();
      if (key !== 'questionario') return '';
      const label = (row.questionarioTemplateLabel || '').trim();
      if (label) return label;
      const tplKey = (row.questionarioTemplateKey || '').toLowerCase();
      if (tplKey === 'check_finale') return 'check';
      return '';
    },
    sectionTitle(row) {
      if (!row) return 'Dettagli';
      const key = (row.stepKey || '').toLowerCase();
      if (key === 'questionario') return 'Questionario Programmi';
      if (key === 'check_finale') return 'Check Finale Programmi';
      if (key === 'feedback_programmi') return 'Feedback Programmi';
      if (key === 'consegna') return 'Consegna';
      return prettifyKey(key || 'Dettagli');
    },
    sectionSubtitle(row) {
      if (!row) return '';
      return row.questionarioTemplateLabel || row.questionarioTemplateKey || row.templateId || '';
    },

    formatDate(d) {
      if (!d) return '';
      const dt = new Date(d);
      return dt.toLocaleDateString('it-IT', { day:'2-digit', month:'2-digit', year:'numeric' });
    },
    formatDateTime(d) {
      if (!d) return '';
      const dt = new Date(d);
      return dt.toLocaleString('it-IT', { day:'2-digit', month:'2-digit', year:'numeric', hour:'2-digit', minute:'2-digit' });
    },
    isToday(value) {
      const date = toDateSafe(value);
      if (!date) return false;
      const now = new Date();
      return date.getFullYear() === now.getFullYear()
        && date.getMonth() === now.getMonth()
        && date.getDate() === now.getDate();
    }
  }
};
</script>

<style scoped>
.fb-red    { background-color: #fee2e2; }
.fb-orange { background-color: #fef3c7; }
.fb-green  { background-color: #dcfce7; }

.note-input {
  width: 87%;
  min-width: 140px;
  padding: 8px 10px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  background: #fff;
  color: #111;
}

.profile-button { background: none; border: none; cursor: pointer; }

.card-surface {
  background: #ffffff;
  border-radius: 18px;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.08);
  padding: 18px 20px;
  margin-top: 18px;
}

.toolbar-card {
  margin-top: 24px;
}

.filters-header {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.accordion-toggle {
  flex: 1 1 320px;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  color: #0f172a;
  cursor: pointer;
  transition: border 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
}

.accordion-toggle:hover {
  background: #fff;
  border-color: #cbd5e1;
  box-shadow: 0 12px 26px rgba(15, 23, 42, 0.08);
}

.accordion-toggle .material-icons {
  font-size: 22px;
  color: #475569;
}

.toggle-copy {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
}

.toggle-title {
  font-weight: 700;
  font-size: 0.95rem;
}

.toggle-subtitle {
  font-size: 0.82rem;
  color: #64748b;
}

.accordion-panel {
  margin-top: 14px;
  padding: 14px 12px;
  border-radius: 14px;
  border: 1px solid #f1f5f9;
  background: linear-gradient(180deg, #f8fafc 0%, #ffffff 100%);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.6);
}

.accordion-enter-active,
.accordion-leave-active {
  transition: all 0.18s ease;
}

.accordion-enter,
.accordion-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}

.toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: flex-end;
}

.toolbar-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 0 0 auto;
}

.toolbar-group--lg { width: 240px; }
.toolbar-group--md { width: 200px; }
.toolbar-group--sm { width: 160px; }

.toolbar-actions {
  display: flex;
  gap: 12px;
  flex: 0 0 auto;
  align-items: center;
}

.toolbar-actions--ghosts {
  flex-wrap: wrap;
}

.toolbar-label {
  font-size: 0.78rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #64748b;
}

.date-range-input {
  width: 100%;
}

.date-range-input--short {
  width: 82% !important;
}

.input {
  width: 100%;
  padding: 10px 14px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  color: #0f172a;
  transition: border 0.2s ease, box-shadow 0.2s ease;
}

.input:focus {
  border-color: #2563eb;
  background: #fff;
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.15);
  outline: none;
}

.input--compact {
  max-width: 220px;
  padding: 8px 12px;
}

.btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 16px;
  border-radius: 12px;
  border: 1px solid transparent;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  transition: transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
  background: #f1f5f9;
  color: #1e293b;
  border-color: #e2e8f0;
}

.btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(15, 23, 42, 0.12);
}

.btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  box-shadow: none;
}

.btn.primary {
  background: linear-gradient(135deg, #2563eb, #4f46e5);
  color: #fff;
}

.btn.ghost {
  background: #f1f5f9;
  color: #1e293b;
  border-color: #e2e8f0;
}

.btn.ghost.active {
  background: #e0f2fe;
  color: #0ea5e9;
  border-color: #bae6fd;
  box-shadow: 0 6px 16px rgba(14, 165, 233, 0.15);
}

.btn.tiny {
  font-size: 0.78rem;
  padding: 6px 10px;
}

.icon-btn,
.stop-btn,
.renew-btn {
  display:inline-flex;
  align-items:center;
  justify-content:center;
  width:36px;
  height:36px;
  padding:0;
  border-radius:10px;
  border:1px solid transparent;
  color:#fff;
  font-size:0.9rem;
  cursor:pointer;
  transition:transform 0.18s ease, box-shadow 0.18s ease;
}
.icon-btn .material-icons,
.stop-btn .material-icons,
.renew-btn .material-icons { font-size:20px; }
.icon-btn:disabled,
.stop-btn:disabled,
.renew-btn:disabled { opacity:.65; cursor: not-allowed; box-shadow:none; transform:none; }
.icon-btn:hover:not(:disabled),
.stop-btn:hover:not(:disabled),
.renew-btn:hover:not(:disabled) {
  transform:translateY(-1px);
  box-shadow:0 6px 16px rgba(15, 23, 42, 0.12);
}
.icon-btn.green { background:#22c55e; border-color:#22c55e; }
.icon-btn.orange{ background:#fb923c; border-color:#fb923c; }
.icon-btn.blue  { background:#3b82f6; border-color:#3b82f6; }
.icon-btn.grey  { background:#7e7e7e; border-color:#646464; }
.stop-btn {
  background:#dc2626;
  border:1px solid #dc2626;
}
.renew-btn {
  background:#8b5cf6;
  border:1px solid #7c3aed;
}

.tickets { overflow-x:auto; }
table { width:100%; min-width:2410px; border-collapse:collapse; table-layout:fixed; }
th, td { padding:8px 12px; text-align:left; border-bottom:1px solid #eee; vertical-align:top; white-space:normal; }
thead th { background:#f7f7f7; }

.col-idx{ width:60px; } .col-azione{ width:160px; }
.col-admin{ width:360px; } .col-note{ width:260px; }
.col-data{ width:160px; } .col-email{ width:260px; }
.col-pagamenti{ width:210px; }
.col-acquisto-flag{ width:110px; }
.col-acquisto{ width:220px; }
.col-acquisto-data{ width:160px; }
.col-studio{ width:200px; }
.col-prodotto{ width:240px; } .col-sequenza{ width:120px; }
.col-step{ width:160px; }

.muted{ color:#6b7280; }

.step-cell { display:flex; align-items:center; gap:6px; flex-wrap:wrap; }
.step-tag {
  display:inline-flex;
  align-items:center;
  gap:4px;
  font-size:0.78rem;
  color:#475569;
  background:#eef2ff;
  border-radius:999px;
  padding:2px 8px;
  border:1px solid #c7d2fe;
}

.admin-col { min-width: 340px; }
.admin-row { display: grid; gap: 6px; }
.admin-chip {
  display:inline-block; padding:3px 8px; border-radius:999px;
  border: 1px solid #e5e7eb; font-size: .78rem; line-height: 1.25rem;
  background:#f3f4f6; color:#374151;
}
.chip-neutral { background:#f3f4f6; }
.chip-green   { background:#dcfce7; color:#065f46; border-color:#bbf7d0; }
.chip-orange  { background:#fff7ed; color:#9a3412; border-color:#fed7aa; }
.chip-blue    { background:#dbeafe; color:#1d4ed8; border-color:#bfdbfe; }
.chip-purple  { background:#ede9fe; color:#6d28d9; border-color:#c4b5fd; }
.chip-red     { background:#fee2e2; color:#991b1b; border-color:#fecaca; }

.chips-line { display:flex; gap:6px; flex-wrap:wrap; align-items:center; }
.row-purchase-renewal {
  background-color: #ecfdf3;
}
.row-payment-issue {
  box-shadow: inset 4px 0 0 #ef4444;
}
.purchase-chip {
  display:inline-flex;
  align-items:center;
  justify-content:center;
  min-width:46px;
  padding:2px 8px;
  border-radius:999px;
  border:1px solid #e5e7eb;
  font-size:.78rem;
  line-height:1.25rem;
  background:#f3f4f6;
  color:#374151;
}
.purchase-chip--yes { background:#dcfce7; color:#065f46; border-color:#bbf7d0; }
.purchase-chip--no { background:#fee2e2; color:#991b1b; border-color:#fecaca; }
.purchase-chip--pending { background:#fef3c7; color:#92400e; border-color:#fde68a; }
.purchase-chip--muted { background:#f3f4f6; color:#6b7280; }
.payment-chip {
  display:inline-flex;
  align-items:center;
  justify-content:center;
  min-width:96px;
  max-width:170px;
  padding:3px 8px;
  border-radius:999px;
  border:1px solid #e5e7eb;
  font-size:.78rem;
  font-weight:800;
  line-height:1.05rem;
  text-transform:uppercase;
  white-space:normal;
  text-align:center;
  background:#f3f4f6;
  color:#374151;
}
.payment-chip--ok { background:#dcfce7; color:#065f46; border-color:#bbf7d0; }
.payment-chip--warning { background:#fef3c7; color:#92400e; border-color:#fde68a; }
.payment-chip--danger { background:#fee2e2; color:#991b1b; border-color:#fecaca; }
.payment-chip--pending { background:#eef2ff; color:#3730a3; border-color:#c7d2fe; }
.payment-chip--muted { background:#f3f4f6; color:#6b7280; border-color:#e5e7eb; }
.purchase-product--coaching {
  color:#2563eb;
  font-weight:600;
}
.buttons-container { display:flex; gap:6px; align-items:center; flex-wrap:wrap; }
.action-button2 { border:1px solid #d1d5db; background:#fff; color:#111; padding:6px 10px; border-radius:10px; font-size:.85rem;}

.needs-box {
  margin-top: 8px; border: 1px solid #e5e7eb; background: #f9fafb;
  border-radius: 10px; padding: 10px; display: grid; gap: 8px;
}
.needs-box .user-input {
  width: 92%; padding: 10px 12px; border-radius: 10px; border: 1px solid #d1d5db; background:#fff; color:#111;
  min-height: 50px;
  height: 50px;
  resize: vertical;
}
.needs-box .buttons-container { display:flex; gap:8px; justify-content:flex-end; align-items:center; flex-wrap:wrap; }
.needs-box .action-button2,
.needs-box .create-user-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 14px;
  height: 40px;
  min-height: 40px;
  font-size: .95rem;
  border-radius: 10px;
}
.create-user-button {
  border: 1px solid #f97316;
  background: linear-gradient(135deg, #fb923c, #f97316);
  color: #fff;
  cursor: pointer;
  font-weight: 700;
  transition: transform 0.18s ease;
}
.create-user-button:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}
.create-user-button:not(:disabled):hover {
  transform: translateY(-1px);
}

.modal .dialog { background:#fff; width:min(1007px,94vw); height:min(95vh, 860px); border-radius:14px; box-shadow:0 24px 60px rgba(0,0,0,.25); padding:18px; display:flex; flex-direction:column; }
.modal-head { display:flex; justify-content:space-between; align-items:center; gap:10px; margin-bottom:8px; }
.meta { display:grid; grid-template-columns: repeat(auto-fit,minmax(240px,1fr)); gap:8px; margin-bottom:10px; }
.meta-step { display:flex; align-items:center; gap:6px; flex-wrap:wrap; }

.modal-scroll { flex:1; overflow:auto; padding-right:8px; }

.answers { display:grid; gap:12px; }
.data-state {
  padding: 14px;
  border: 1px dashed #d1d5db;
  border-radius: 12px;
  font-size: 0.92rem;
  color: #1f2937;
  text-align: center;
}
.data-state.error {
  color: #b91c1c;
  border-color: rgba(185, 28, 28, 0.35);
  background: rgba(248, 113, 113, 0.08);
}

.modal-sections {
  display: grid;
  gap: 18px;
}

.modal-section {
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  background: #fff;
  padding: 16px 18px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.modal-section__head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  flex-wrap: wrap;
}

.modal-section__head h4 {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: #0f172a;
}

.modal-section__subtitle {
  margin: 4px 0 0;
  font-size: 0.85rem;
  color: #475569;
}

.modal-section__meta {
  font-size: 0.82rem;
  color: #1f2937;
  font-weight: 500;
}

.modal-section__body {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.modal-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.modal-group__title {
  margin: 0;
  font-size: 0.88rem;
  font-weight: 600;
  color: #1d4ed8;
  text-transform: capitalize;
}

.modal-row {
  display: grid;
  grid-template-columns: minmax(150px, 220px) minmax(0, 1fr);
  gap: 12px;
  align-items: start;
  padding: 10px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #f8fafc;
}

.modal-row.multiline {
  align-items: stretch;
}

.modal-row__key {
  font-size: 0.86rem;
  font-weight: 600;
  color: #1f2937;
  word-break: break-word;
}

.modal-row__value {
  font-size: 0.86rem;
  color: #0f172a;
  word-break: break-word;
}

.modal-row__value pre {
  margin: 0;
  font-size: 0.82rem;
  background: none;
  white-space: pre-wrap;
  font-family: 'SFMono-Regular', ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace;
}
.row-stop td {
  background: #fff1f2;
  color: #7f1d1d;
}

.row-duplicate td {
  box-shadow: inset 4px 0 #f97316;
  background: #fff7ed;
}
</style>
<style scoped src="../../assets/css/staff-questionnaires-mobile.css"></style>
<style scoped src="../../assets/css/staff-questionnaires-mobile-modal.css"></style>
